import { useState, useEffect, useRef, useContext, useMemo, use } from "react";
import { ButtonGroup, DropdownButton, IconButton, MultiSelectDropdown, StandardButton } from "../atoms/buttons";
import { CheckRectangle } from "../atoms/checkbox";
import Checkbox from "../atoms/checkboxnew";
import RadioButton from "../atoms/radiobutton";
import ScrollableLayout, { GridLayout, HorizontalLayout, VerticalLayout } from "./layout";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "./modal";
import { ColorPickerForm, CustomSelectinputForm, InputForm, SelectInputForm, TextAreaForm } from "../atoms/input";
import { icon } from "../functions/icons";
import { Alert } from "./alert";
import { Spinner } from "../atoms/spinner";
import Tabs from "./tabs";
import { postAPI, getAPI, postAPImedia, fetchAPI, deleteAPI, updateAPI } from "../api/api";
import { SkeletonDiv } from "../atoms/skeletonloaders";
import { InputFile } from "../atoms/input";
import { PageContext, ToastContext } from "../App";
import { CheckOrder, OrderDetails } from "../molecule/OrderMolecules";
import { StandardComp } from "../atoms/standardComp";
import { UserContext } from "../App";
import { ip } from "../api/api";
import { IconFile, IconPdf } from "@tabler/icons-react";
import { InformationPill } from "../atoms/informationPill";
import { PdfFileInput } from "../atoms/pdfInput";
import QRCode from "react-qr-code";
import { ScoreOverview } from "./ScoreOverview";
import { ProjectStepCardComp } from "./ProjectStepCardComp";
import { ExtraConfigPanel } from "../molecule/ExtraConfigPanel";
import { DocumentsPanel } from "../molecule/DocumentsPanel";
import { PDFPreview } from "./PDFPreview";
import { set } from "date-fns";
import { padding } from "polished";
import { NewStep, Step } from "../atoms/step";
import SjabloonSuggestion from "./SjabloonSuggestion";
import { Skills } from "../molecule/Skills";
import Review from "../screens/review";
import UploadMedia from "../molecule/UploadMedia";
import { CampagneTableComp } from "./campagneTableComp";
import { useFeatures } from "../FeaturesContext";
import { AIDiagramGenerator } from "./AIDiagramGenerator";
import { AIImageGenerator } from "./AIImageGenerator";




export function SortingModal({ visible, sortingOptions, setSortingOptions, dismissedModal, applySortOptions }) {
    const userContext = useContext(UserContext);

    function setSortingOption(e) {
        setSortingOptions({ ...sortingOptions, sort_by: e.target.value });
    }

    function setSortingType(e) {
        setSortingOptions({ ...sortingOptions, type: e.target.value });
    }

    function setFilters(e) {
        if (e.target.checked) {
            setSortingOptions({
                ...sortingOptions,
                filters: [...sortingOptions.filters, e.target.value]
            });
        } else {
            setSortingOptions({
                ...sortingOptions,
                filters: sortingOptions.filters.filter(filter => filter !== e.target.value)
            });
        }
    }

    return <Modal
        dismissable={dismissedModal}
        visible={visible}
        size="small"
        content={
            <>
                <ModalTitle dismissable={dismissedModal} hasXmark={true} title="Sorteer- en filteropties" />
                <ModalBody
                    content={
                        <>
                            <HorizontalLayout style={{ gap: "1rem" }}>
                                <h6 className="standard-text-color">Sorteren</h6>
                                <div style={{ width: "100%", borderBottom: "1px solid #ccc" }}></div>
                            </HorizontalLayout>
                            <GridLayout
                                onChange={setSortingOption}
                                className="standard-margin-bottom"
                                columnsTemplate="auto 1fr"
                                gap="0.25rem"
                                style={{ alignItems: "center" }}
                            >
                                <RadioButton checked={sortingOptions.sort_by == "creation_date"} id="course_sortingoptions_cd" name="sorting_options" value="creation_date" />
                                <label for="course_sortingoptions_cd" className="standard-text-color">Aanmaakdatum</label>
                                <RadioButton checked={sortingOptions.sort_by == "title"} name="sorting_options" value="title" id="course_sortingoptions_title" />
                                <label for="course_sortingoptions_title" className="standard-text-color">Titel</label>
                                <RadioButton id="course_sortingoptions_ld" checked={sortingOptions.sort_by == "lesson_duration"} name="sorting_options" value="lesson_duration" />
                                <label for="course_sortingoptions_ld" className="standard-text-color">Leshoeveelheid</label>
                                <RadioButton id="course_sortingoptions_enrollments" checked={sortingOptions.sort_by == "enrollments"} name="sorting_options" value="enrollments" />
                                <label for="course_sortingoptions_enrollments" className="standard-text-color">Deelnemers</label>
                            </GridLayout>
                            <HorizontalLayout style={{ gap: "1rem" }}>
                                <h6 className="standard-text-color">Rangschikorde</h6>
                                <div style={{ width: "100%", borderBottom: "1px solid #ccc" }}></div>
                            </HorizontalLayout>
                            <GridLayout
                                onChange={setSortingType}
                                className="standard-margin-bottom"
                                columnsTemplate="auto 1fr"
                                gap="0.25rem"
                                style={{ alignItems: "center" }}
                            >
                                <RadioButton checked={sortingOptions.type === "ASC"} name="sort_type" value="ASC" id="course_sortingoptions_asc" />
                                <label for="course_sortingoptions_asc" className="standard-text-color">Oplopend</label>
                                <RadioButton id="course_sortingoptions_desc" checked={sortingOptions.type === "DESC"} name="sort_type" value="DESC" />
                                <label for="course_sortingoptions_desc" className="standard-text-color">Aflopend</label>
                            </GridLayout>
                            {(userContext.permissions.includes("courses.manage")) ? <><HorizontalLayout style={{ gap: "1rem" }}>
                                <h6 className="standard-text-color">Filters</h6>
                                <div style={{ width: "100%", borderBottom: "1px solid #ccc" }}></div>
                            </HorizontalLayout>
                                <GridLayout
                                    onChange={setFilters}
                                    columnsTemplate="auto 1fr"
                                    gap="0.25rem"
                                    style={{ alignItems: "center" }}
                                >
                                    <Checkbox checked={sortingOptions.filters.includes("active_lessons")} name="filter_options" value="active_lessons" />
                                    <p className="standard-text-color">Actieve lessen</p>
                                    <Checkbox checked={sortingOptions.filters.includes("inactive_lessons")} name="filter_options" value="inactive_lessons" />
                                    <p className="standard-text-color">Inactieve lessen</p>
                                    <Checkbox checked={sortingOptions.filters.includes("deactivated_lessons")} name="filter_options" value="deactivated_lessons" />
                                    <p className="standard-text-color">Gedeactiveerde cursussen</p>
                                </GridLayout></> : ""}
                        </>
                    }
                />
                <ModalFooter
                    content={
                        <>
                            <StandardButton onClick={() => applySortOptions()} title={"Toepassen"} />
                        </>
                    }
                />
            </>
        }
    />
}

export function AnishCreateCourseModal({ visible, dismissedModal, aiCourseCreated }) {
    const navigationContext = useContext(PageContext);
    const [currentStep, setCurrentStep] = useState(1);
    const { isFeatureEnabled } = useFeatures();
    const [courseConfig, setCourseConfig] = useState({
        "title": "",
        "description": "",
        "target_group": "",
        "difficulty": "",
        "creation_type": 0,
    });

    function set_course_config(configItem, value) {
        setCourseConfig((v) => {
            var old_value = { ...v };
            old_value[configItem] = value;
            return old_value;
        })
    }

    function next_step() {
        var _currentStep = currentStep;
        _currentStep++;
        setCurrentStep(_currentStep);
    }

    function previous_step() {
        var _currentStep = currentStep;
        _currentStep--;
        setCurrentStep(_currentStep);
    }

    var preparedSelectionOptions = [
        {
            content: <div title="Het blanco sjabloon moet u zelf invullen.">{icon("sandbox", 20)}<br />Blanco</div>,
            selected: courseConfig["creation_type"] === 0,
            onClick: () => set_course_config("creation_type", 0)
        },
        {
            content: <div title="Het standaard sjabloon geeft alvast een structuur die voor uw quiz kan werken.">{icon("book", 20)}<br />Structuur</div>,
            selected: courseConfig["creation_type"] === 1,
            onClick: () => set_course_config("creation_type", 1)
        }
    ]

    if (isFeatureEnabled(13)) preparedSelectionOptions += {
        content: <div title="Het AI sjabloon maakt de gehele cursus aan (met content), geef daarom een zo goed mogelijke titel en omschrijving aan.">{icon("wand", 20)}<br />AI</div>,
        selected: courseConfig["creation_type"] === 2,
        onClick: () => set_course_config("creation_type", 2)
    }

    return (
        <Modal dismissable={dismissedModal} visible={visible} size="small" content={
            <>
                <ModalTitle title="Cursusinstellingen" />
                <ModalBody content={
                    <>
                        <GridLayout gap="0.75rem" columnsTemplate="1fr 1fr 1fr">
                            <NewStep status={currentStep == 1 ? "active" : currentStep > 1 ? "completed" : ""} number={1} title="Cursusinformatie" />
                            <NewStep status={currentStep == 2 ? "active" : currentStep > 2 ? "completed" : ""} number={2} title="AI-configuratie" />
                            <NewStep status={currentStep == 3 ? "active" : currentStep > 3 ? "completed" : ""} number={3} title="Bestanden" />
                        </GridLayout>
                        <br />
                        {currentStep == 1 && <>
                            <InputForm title={"Titel"} value={courseConfig.title} typeInput={(e) => set_course_config("title", e)} />
                            <TextAreaForm title={"Korte omschrijving"} value={courseConfig.description} typeInput={(e) => set_course_config("description", e)} />
                            <SelectInputForm
                                onChange={(e) => set_course_config("target_group", e)}
                                title={<>Doelgroep <span title="Doelgroep van de cursus, dit helpt ons de cursus af te stellen op jouw behoeften en is administratief handig.">{icon("question")}</span></>}
                                options={[
                                    <option value={"automatic"} defaultValue>Laat AI kiezen</option>,
                                    <option value={"text_first"}>Eerst leren, daarna vragen</option>,
                                    <option value={"mixed"}>Leren en vragen gehusseld</option>
                                ]}
                            />
                            <ButtonGroup
                                size="large"
                                buttons={preparedSelectionOptions}
                            />
                        </>}
                        {currentStep == 2 && <>
                            <SelectInputForm
                                onChange={(e) => set_course_config("target_group", e)}
                                title={<>Type cursus <span title="Doelgroep van de cursus, dit helpt ons de cursus af te stellen op jouw behoeften en is administratief handig.">{icon("question")}</span></>}
                                options={[
                                    <option value={"standard"} defaultValue>Standaardcursus</option>,
                                    <option value={"microlearning"}>Microlearning</option>,
                                    <option value={"broadening"}>Verbredende learning</option>,
                                    <option value={"deepening"}>Verdiepende learning</option>
                                ]}
                            />
                            <InputForm title={"Titel"} value={courseConfig.title} typeInput={(e) => setCourseConfig("title", e)} />
                            <TextAreaForm style={{ maxHeight: "3rem" }} title={"Korte omschrijving"} value={courseConfig.description} typeInput={(e) => setCourseConfig("description", e)} />
                            <SelectInputForm
                                onChange={(e) => set_course_config("target_group", e)}
                                title={<>Doelgroep <span title="Doelgroep van de cursus, dit helpt ons de cursus af te stellen op jouw behoeften en is administratief handig.">{icon("question")}</span></>}
                                options={[
                                    <option value={"automatic"} defaultValue>Laat AI kiezen</option>,
                                    <option value={"text_first"}>Eerst leren, daarna vragen</option>,
                                    <option value={"mixed"}>Leren en vragen gehusseld</option>
                                ]}
                            />
                        </>}
                    </>
                } />
                <ModalFooter>
                    {currentStep !== 1 && <StandardButton onClick={() => previous_step()} style={{ "marginRight": "0px", "fontWeight": "500" }} title={<>{icon("arrow-left")}&nbsp;&nbsp;Vorige stap</>} />}
                    <StandardButton onClick={() => next_step()} style={{ "marginRight": "0px", "fontWeight": "500" }} title={<>Volgende stap&nbsp;&nbsp;{icon("arrow-right")}</>} />
                </ModalFooter>
            </>
        } />
    )
}

export function CreateCourseModal({ visible, createCourse, dismissedModal, aiCourseCreated, goTo, AiStarted ,CustomerStage}) {
    const navigationContext = useContext(PageContext);
    const [courseInfo, setCourseInfo] = useState({
        title: "",
        description: "",
        template: 0,
        level: 2,
        lesson_count: 1
    });
    const [extraData, setExtraData] = useState({
        research_mode: "medium",
        structure_mode: "automatic",
        ai_instructions: "",
        exam: false,
        allow_converter: false,
        allow_file_upload: false,
        pdf_files: []
    });
    const [errorMessage, setErrorMessage] = useState("");
    const [aiCreatingCourse, setAiCreatingCourse] = useState(false);

    const { showToast } = useContext(ToastContext);
    const [lastSource, setLastSource] = useState(null);
    const [modalPage, setModalPage] = useState(1);
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const [uploadingDocument, setUploadingDocument] = useState(false)
    const [textTranscription, setTextTranscription] = useState(null);
    const [textTranscriptionFailed, setTextTranscriptionFailed] = useState(false);
    const [canSave, setCanSave] = useState(true);
    const MAX_LENGTH = 10000;
    function createNewCourse() {
        if (!checkInput()) return;
        if (!canSave) {
            setModalPage(3);
            setErrorMessage("Fout: De transcriptie is te lang. Ga naar de transcriptiepagina en verklein deze.");
            setTimeout(() => setErrorMessage(""), 4000);
            return;
        }
        addCourse();
    }

    function checkInput() {
        setErrorMessage("");
        if (!courseInfo.title || !courseInfo.description) {
            setErrorMessage("Fout: Cursus titel en beschrijving is verplicht!");
            setTimeout(() => {
                setErrorMessage("");
            }, 3000);
            return false;
        }
        if ((courseInfo.template === 1 || courseInfo.template === 2) && !courseInfo.description) {
            setErrorMessage("Fout: Cursusomschrijving is verplicht voor dit sjabloon!");
            setTimeout(() => {
                setErrorMessage("");
            }, 3000);
            return false;
        }
        return true;
    }

    const addPdf = async () => {
        const formData = new FormData();
        extraData.pdf_files.forEach((file, i) => {
            formData.append('documents', file);
        });
        const query = "api/media/add-document"
        const res = await postAPImedia(query, formData);
        if (res.status === "ok" || res.data) {
            return res.data;
        } else {
            return 0
        }

    }

    const resetCourse = () => {
        setCourseInfo({
            title: "",
            description: "",
            template: 0,
            level: 2,
            lesson_count: 1
        });

        setExtraData({
            research_mode: "medium",
            structure_mode: "automatic",
            ai_instructions: "",
            exam: false,
            allow_converter: false,
            allow_file_upload: false,
            pdf_files: []
        });

        setUploadingDocument(false);
        setUploadedDocuments([]);
        setAiCreatingCourse(false);
    };

    const addCourse = async () => {
        setAiCreatingCourse(true);
        const query = "api/courses/create";

        let body = {
            title: courseInfo.title,
            description: courseInfo.description,
            level: courseInfo.level,
            lesson_count: courseInfo.lesson_count,
            course_template: courseInfo.template,
            price: 0,
            yt_url: "http",
            customerStage:CustomerStage
        };

        if (courseInfo.template === 2) {
            body = {
                ...body,
                ...extraData,
                documents: uploadedDocuments,
                text_transcription: extraData.allow_converter && textTranscription
            };
        }

        await postAPI(query, body);
        resetCourse()
        aiCourseCreated()
        AiStarted()
        navigationContext.handleNavigation({
            navigation: 2,
            courseID: 0,
            enrollment: 0
        });


    };
    function error(type) {
        if (type === "empty") {
            setErrorMessage("Voeg eerst een mediabestand of PDF-bestand toe voordat je verder gaat.");
            setTimeout(() => setErrorMessage(""), 5000);
            return null;
        }
        if (typeof extraData.media === "string" && (extraData.media.startsWith("http://") || extraData.media.startsWith("https://"))) {
            setErrorMessage("Controleer of je YouTube-video bestaat en niet langer is dan 30 minuten.");
        } else {
            setErrorMessage("Er is iets misgegaan bij het verwerken van het bestand. Probeer het later opnieuw.");
        }
        setTimeout(() => setErrorMessage(""), 5000);
        setTextTranscriptionFailed(true);
        return null;
    }
    
    const addMedia = async () => {
        if (!extraData.media) return null;
        const formData = new FormData();
        formData.append('media', extraData.media);
        formData.append('max_length', MAX_LENGTH);
        try {
            const res = await postAPImedia("api/media/convert-upload", formData);
            console.log("Media upload response:", res)
            if (res.status === "ok") {
                setTextTranscriptionFailed(false);
                return res.data;
            } else if (res.status === "error") {
                return error()
            }
        } catch (err) {
            setTextTranscriptionFailed(true);
            setErrorMessage("Er is een onverwachte fout opgetreden. Probeer het later opnieuw.");
            setTimeout(() => setErrorMessage(""), 5000);
            return null;
        }
    };
    async function handleMediaChange (currentSource) {
        setUploadingDocument(true);
        const text = await addMedia();
        if (text) {
            setTextTranscription(text);
            setLastSource(currentSource);
            setErrorMessage("");
        }
        setUploadingDocument(false);
    }
    async function handlePDFUpload () {
        setUploadingDocument(true);
        const uploaded = await addPdf();
        if (uploaded) {
            setUploadingDocument(false)
            setUploadedDocuments([...uploadedDocuments, ...uploaded]);
            setErrorMessage("");
        } 
        setUploadingDocument(false)
    }
    function getMediaSource(media) {
        if (!media) return null;
        if (typeof media === "string") return media; 
        if (media instanceof File) return `${media.name}_${media.size}_${media.lastModified}`;
        return null; 
    }
    const handleUploadAndBack = async () => {
        const currentSource = getMediaSource(extraData.media);
        const mediaChanged = currentSource !== lastSource;
        console.log("Media changed:", extraData.allow_file_upload, extraData.pdf_files);
        if ((extraData.allow_converter && !textTranscription && !extraData.media) || (extraData.allow_file_upload && !extraData.pdf_files)) { return error("empty"); }
        if (extraData.allow_converter || mediaChanged) { await handleMediaChange(currentSource); }
        if (extraData.allow_file_upload ===true  || extraData.pdf_files.length > 0) { await handlePDFUpload();}

        setModalPage(1);
    };
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth < 768;

    useEffect(() => {
        const onResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return (
        <Modal hidden={false} height={null} dismissable={dismissedModal} visible={visible} size="small">
            <ModalTitle dismissable={dismissedModal} hasXmark={true} title="Nieuwe cursus aanmaken" />
            {(aiCreatingCourse || (modalPage === 2 && uploadingDocument)) &&
                <ModalSpinner title={aiCreatingCourse ? "Cursus aanmaken..." : "Bestand(en) uploaden..."} />
            }
            <ModalBody style={{ minWidth: "512px", maxWidth: "512px" }}>
                <CoursePages 
                    setCanSave={setCanSave}
                    modalPage={modalPage}
                    courseInfo={courseInfo}
                    setCourseInfo={setCourseInfo}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    textTranscription={textTranscription}
                    setTextTranscription={setTextTranscription}
                    textTranscriptionFailed={textTranscriptionFailed}
                    MAX_LENGTH={MAX_LENGTH}
                />
            </ModalBody>
            <ModalFooter style={{ minWidth: isMobile ? "100%" : "512px" , maxWidth: isMobile ? "100%" : "512px" }}>
                <FooterButtons 
                    errorMessage={errorMessage}
                    extraData={extraData}
                    textTranscription={textTranscription}
                    modalPage={modalPage}
                    courseTemplate={courseInfo.template}
                    setModalPage={setModalPage}
                    handleUploadAndBack={handleUploadAndBack}
                    createNewCourse={createNewCourse}
                    />
            </ModalFooter>
        </Modal>
    );
}

const CoursePages = ({modalPage, courseInfo, setCourseInfo, extraData, setExtraData, textTranscription, setTextTranscription, textTranscriptionFailed, setCanSave, MAX_LENGTH}) => {
    switch (modalPage) {
        case 1: return <CourseInfoPage courseInfo={courseInfo}  updateCourseInfo={(key, value) => setCourseInfo(prev => ({ ...prev, [key]: value }))}  />
        case 2: return <CourseExtraInfoPage textTranscriptionFailed={textTranscriptionFailed} extraData={extraData} updateExtraData={(key, value) => setExtraData(prev => ({ ...prev, [key]: value }))} />
        case 3: return <TextTranscriptionPreviewPage setCanSave={setCanSave} textTranscription={textTranscription} setTextTranscription={setTextTranscription} MAX_LENGTH={MAX_LENGTH} />
        default: return <></>
    }
}

const TextTranscriptionPreviewPage = ({ textTranscription, setTextTranscription, setCanSave, MAX_LENGTH }) => {
    const [collapse, setCollapse] = useState(true);
    const [error, setError] = useState("");
    
    const manageTextChange = (v) => {
        setTextTranscription(v);
        if (v.length <= MAX_LENGTH) {
            setCanSave(true);
            setError("");
        } else {
            setCanSave(false);
            setError(`De transcriptie mag niet langer zijn dan ${MAX_LENGTH} tekens.`);
        }
    };
    return(
        <>
        <TextAreaForm size={!collapse && "large"} typeInput={(v) => manageTextChange(v)} value={textTranscription} />
        <HorizontalLayout>
            <IconButton onClick={() => setCollapse(!collapse)} icon2={collapse ? "chevron-down" : "chevron-up"} />
            <p className="small-text-light">
                {textTranscription ? textTranscription.length : 0} / {MAX_LENGTH} tekens
            </p>
        </HorizontalLayout> 
        {error && <Alert className={"standard-small-margin-top"} type="error" message={error} />}
        </>
        
    )
}
const CourseInfoPage = ({ courseInfo, updateCourseInfo }) => {
    const { isFeatureEnabled } = useFeatures();

    const templateButtons = [
        {
            content: <div title="Het blanco sjabloon moet u zelf invullen.">{icon("sandbox", 20)}<br />Blanco</div>,
            selected: courseInfo.template === 0,
            onClick: () => updateCourseInfo("template", 0)
        },
        {
            content: <div title="Het standaard sjabloon geeft alvast een structuur die voor uw quiz kan werken.">{icon("book", 20)}<br />Structuur</div>,
            selected: courseInfo.template === 1,
            onClick: () => updateCourseInfo("template", 1)
        },
        ...(isFeatureEnabled(13) || isFeatureEnabled(29) ? [{
            content: <div title="Het AI sjabloon maakt de gehele cursus aan (met content), geef daarom een zo goed mogelijke titel en omschrijving aan.">{icon("wand", 20)}<br />AI</div>,
            selected: courseInfo.template === 2,
            onClick: () => updateCourseInfo("template", 2)
        }] : [])
    ];

    return (
        <>
            <InputForm
                title="Titel"
                value={courseInfo.title}
                typeInput={(v) => updateCourseInfo("title", v)}
            />
            <TextAreaForm
                title="Beschrijving"
                value={courseInfo.description}
                typeInput={(v) => updateCourseInfo("description", v)}
            />
            <p className="small-text-dark semi-bold" style={{ marginBottom: "0.5rem" }}>Sjabloon</p>
            <ButtonGroup size="large" buttons={templateButtons} />
            <HorizontalLayout style={{ gap: "1rem", marginTop: "1rem", transitionDuration: "0.25s" }}>
                {(courseInfo.template >= 0) && (
                    <SelectInputForm
                        value={courseInfo.level}
                        onChange={(v) => updateCourseInfo("level", v)}
                        title="Moeilijkheidsgraad"
                        options={[
                            <option value={1}>Makkelijk</option>,
                            <option value={2}>Gemiddeld</option>,
                            <option value={3}>Moeilijk</option>
                        ]}
                    />
                )}
                {courseInfo.template >= 1 && (
                    <SelectInputForm
                        value={courseInfo.lesson_count}
                        onChange={(v) => updateCourseInfo("lesson_count", v)}
                        title="Aantal lessen"
                        options={Array.from({ length: 9 }, (_, i) => (
                            <option value={i + 1}>{i + 1}</option>
                        ))}
                    />
                )}
            </HorizontalLayout>
        </>
    );
};



const CourseExtraInfoPage = ({ extraData, updateExtraData, textTranscriptionFailed }) => {
    return (
        <>
            <SelectInputForm
                value={extraData.research_mode}
                onChange={(value) => updateExtraData("research_mode", value)}
                title="Research diepte"
                options={[
                    <option value="none">Geen</option>,
                    <option value="medium">Gemiddeld</option>,
                    <option value="extreme">Uitgebreid</option>
                ]}
            />
            <SelectInputForm
                value={extraData.structure_mode}
                onChange={(value) => updateExtraData("structure_mode", value)}
                title="Cursusstructuur"
                options={[
                    <option value="automatic">Laat AI kiezen</option>,
                    <option value="text_first">Eerst leren, daarna vragen</option>,
                    <option value="mixed">Leren en vragen gehusseld</option>
                ]}
            />
            <TextAreaForm
                value={extraData.ai_instructions}
                typeInput={(v) => updateExtraData("ai_instructions", v)}
                placeholder="Extra instructies..."
                title="Cursusopzet"
            />
            <div onClick={() => updateExtraData("exam", !extraData.exam)} className="horizontal setting-notification" >
                {extraData.exam ? icon('off') : icon("on")}
                <p className="small-text-dark standard-bold">
                    Toets de cursist op het einde.
                </p>
            </div>
            <div onClick={() => updateExtraData("allow_converter", !extraData.allow_converter)} className="horizontal setting-notification" >
                {extraData.allow_converter ? icon('off') : icon("on")}
                <p className="small-text-dark standard-bold">
                    Upload <strong className="audio-tool-tip">audio*</strong>/video voor context
                </p>
            </div>
            {extraData.allow_converter && (
               <UploadMedia textTranscriptionFailed={textTranscriptionFailed} setMedia={(file) => updateExtraData("media", file)} media={extraData.media} />
            )}
            <div onClick={() => updateExtraData("allow_file_upload", !extraData.allow_file_upload)} className="horizontal setting-notification" >
                {extraData.allow_file_upload ? icon('off') : icon("on")}
                <p className="small-text-dark standard-bold">
                    Upload PDF bestanden
                </p>
            </div>
            {extraData.allow_file_upload && (
                <PdfFileInput
                    value={extraData.pdf_files}
                    onFileSelect={(files) => updateExtraData("pdf_files", files)}
                />
            )}
        </>
    );
};

const FooterButtons = ({errorMessage, extraData, textTranscription, modalPage, courseTemplate, setModalPage, handleUploadAndBack, createNewCourse}) => {
    return (
        <HorizontalLayout style={{ width: "100%", justifyContent: "flex-end", alignItems: errorMessage && textTranscription && "flex-end" }}>
            <VerticalLayout style={{ gap: errorMessage && textTranscription  && ".5rem" }}>
                {errorMessage && <Alert className="error-button" type="error" message={errorMessage} />}
                {(extraData.media && extraData.allow_converter) && textTranscription && modalPage !== 3 && <StandardButton onClick={() => setModalPage(3)} style={{ marginRight: "auto", marginLeft: "0",  }} title={icon("text_transcription")} />  }
            </VerticalLayout> 
            {(extraData.media) && textTranscription && modalPage === 3 && <StandardButton onClick={() => setModalPage(1)} style={{ marginLeft: "0",  }} title={icon("arrow-left")} />  }
            {courseTemplate === 2 && modalPage === 1 && (
                <StandardButton onClick={() => setModalPage(2)} title={icon("settings")} />
            )}
            {courseTemplate === 2 && modalPage === 2 && (
                <StandardButton onClick={handleUploadAndBack} title="Opslaan" />
            )}
            {modalPage === 1 && (
                <StandardButton onClick={createNewCourse} title="Aanmaken" />
            )}
        </HorizontalLayout>
    )
}
// function CreateCoursePage1({ data, setData }) {
//     const [departments, setDepartments] = useState([]);
//     const LoadDepartments = async () => {
//         const query = "api/business/departments";
//         const res = await getAPI(query);
//         console.log("departments", res);
//         if (res.status === "ok") {
//             setDepartments(res.data);
//         }
//     };

//     const AudienceOptions = () => {
//         return [
//             <option key={0} value={0}>Iedereen</option>,
//             ...departments.map((dept) => (
//             <option key={dept.id_department} value={dept.id_department}>
//                 {dept.department_name}
//             </option>
//         ))
//         ];
//     };
//     console.log("audience options", AudienceOptions());
//     useEffect(() => {
//         LoadDepartments();
//     }, []);
//   return (
//     <>
//     <InputForm
//         style={{ marginTop: "1rem" }}
//         title="Titel"
//         value={data.courseTitle}
//         typeInput={(val) => setData({ ...data, courseTitle: val })}
//     />
//     <TextAreaForm
//         size={"small"}
//         title="Beschrijving"
//         value={data.courseDescription}
//         typeInput={(val) => setData({ ...data, courseDescription: val })}
//     />
//     <SelectInputForm
//         onChange={(val) => setData({ ...data, courseAudience: parseInt(val) })}
//         title="Doelgroep"
//         options={AudienceOptions()}
//     />
//     <SelectInputForm
//         onChange={(val) => setData({ ...data, courseDifficulty: val })}
//         title="Moeilijkheidsgraad"
//         options={[
//             <option value={1}>Makkelijk</option>,
//             <option value={2}>Gemiddeld</option>,
//             <option value={3}>Moeilijk</option>,
//         ]}
//         />
//       <p className="small-text-dark semi-bold" style={{ marginBottom: "0.5rem" }}>Sjabloon</p>
//       <ButtonGroup
//         size="large"
//         buttons={[{
//           content: <div title="Het blanco sjabloon moet u zelf invullen.">{icon("sandbox", 20)}<br />Blanco</div>,
//           selected: data.courseTemplate === 0,
//           onClick: () => setData({ ...data, courseTemplate: 0 }),
//         },
//           {
//             content: <div title="Het standaard sjabloon geeft alvast een structuur die voor uw quiz kan werken.">{icon("book", 20)}<br />Structuur</div>,
//             selected: data.courseTemplate === 1,
//             onClick: () => setData({ ...data, courseTemplate: 1 }),
//           },
//           {
//             content: <div title="Het AI sjabloon maakt de gehele cursus aan (met content)...">{icon("wand", 20)}<br />AI</div>,
//             selected: data.courseTemplate === 2,
//             onClick: () => setData({ ...data, courseTemplate: 2 }),
//           },
//         ]}
//       />
//     </>
//   );
// }

// function CreateCoursePage2({ data, setData }) {
//     const [loading, setLoading] = useState(false);
//     const [skills, setSkills] = useState([]);
//     const [loadingSjabloon, setLoadingSjabloon] = useState(false);
//     const [suggestedSkills, setSuggestedSkills] = useState([]);
//     const courseOptions = [
//     { value: "micro", label: "Microlearning", sub: "Korte, snelle lessen van 5-10 minuten" },
//     { value: "short", label: "Korte cursus", sub: "Lessen van 15-30 minuten" },
//     { value: "medium", label: "Standaard cursus", sub: "Gemiddelde lengte van 30-60 minuten" },
//     { value: "long", label: "Lange cursus", sub: "Lessen van 1-2 uur" },
//     { value: "broad", label: "Verbredende cursus", sub: "Geeft extra context en meerdere invalshoeken rond een thema" },
//     { value: "deep", label: "Verdiepende cursus", sub: "Gaat diep in op één specifiek onderwerp" },
//     ];
//     const courseFormatOptions = [
//         { value: "uitleg", label: "Uitleg / theorie", sub: "Basiskennis en theorie uitgelegd" },
//         { value: "instructie", label: "Stapsgewijze instructie", sub: "Stap-voor-stap handleidingen" },
//         { value: "voorbeeld", label: "Praktijkvoorbeeld / casus", sub: "Concrete voorbeelden en cases" },
//         { value: "samenvatting", label: "Samenvatting", sub: "Belangrijkste punten samengevat" },
//         { value: "tiplijst", label: "Tips / do's & don'ts", sub: "Handige tips en valkuilen" },
//         { value: "reflectie", label: "Reflectievraag", sub: "Vragen om zelf te reflecteren" },
//     ];
// const fakeSjabloons = [
//   { 
//     title: "Sjabloon 1", 
//     description: "Een kort introductiesjabloon voor beginners", 
//     structure: [
//       { type: "text-size", name: "Introductie" },
//       { type: "add-video", name: "Video 1" },
//       { type: "add-video", name: "Video 2" },
//       { type: "add-video", name: "Video 3" },
//       { type: "mail", name: "Korte toets" },
//     ]
//   },
//   { 
//     title: "Sjabloon 2", 
//     description: "Een voorbeeldsjabloon voor praktijkcasussen", 
//     structure: [
//       { type: "text-size", name: "Casus overzicht" },
//       { type: "add-video", name: "Case video" },
//       { type: "text-size", name: "Opdracht maken" },
//       { type: "text-size", name: "Reflectievraag" },
//     ]
//   },
//   { 
//     title: "Sjabloon 3", 
//     description: "Een uitgebreid sjabloon met extra tips", 
//     structure: [
//       { type: "text-size", name: "Theorieblok" },
//       { type: "add-video", name: "Theorie video" },
//       { type: "add-video", name: "Praktijkvideo" },
//       { type: "mail", name: "Kennischeck" },
//       { type: "text-size", name: "Samenvatting & tips" },
//     ]
//   },
// ];

//   const fakeSuggestedSkills = [
//         { id_skill: 1, skill_name: "Communicatie" },
//         { id_skill: 2, skill_name: "Projectmanagement" },
//         { id_skill: 3, skill_name: "Teamwork" },
//         { id_skill: 4, skill_name: "Creatief denken" },
//     ];
// const loadSuggestions = () => {
//     setLoadingSjabloon(true);
//         setTimeout(() => setLoadingSjabloon(false), 5000); 
// };
// useEffect(() => {
//     loadSuggestions();
// }, []);

//   return (
//     <ScrollableLayout className="standard-margin-top">
//     <InputForm placeholder={"Vul hier de leerdoelen in"} typeInput={(val) => setData({ ...data, learningObjectives: val })} style={{ marginTop: "1rem" }} title={"Leerdoelen"} />
//     <CustomSelectinputForm
//         onChange={(val) => setData({ ...data, courseStructureMode: val })}
//         title={<>Type cursus {icon("question")}</>}
//         options={courseOptions}
//     />
//     <CustomSelectinputForm
//         options={courseFormatOptions}
//         onChange={(val) => setData({ ...data, courseFormat: val })}
//         placeholder="Selecteer contentformaat"
//         title="Contentformaat"
//     />
//     <SjabloonSuggestion loading={loadingSjabloon} Sjabloons={fakeSjabloons} />
//     <HorizontalLayout className="skills-comp standard-margin-top relative" style={{ width: "auto", height: "auto", gap: "1rem", border: "1px solid var(--border-color)", borderRadius: "calc(10px * var(--br-scale))", alignItems: "flex-start", }}>
//         <Skills
//             suggestedSkills={fakeSuggestedSkills}
//             loadSuggestions={loadSuggestions}
//             loading={loading}
//             setLoading={setLoading}
//             skills={skills}
//             setSkills={setSkills}
//             onAddSkill={(newSkills) => console.log("Added skills:", newSkills)}
//             onRemoveSkill={(removedSkill) => console.log("Removed skill:", removedSkill)}
//         />
//     </HorizontalLayout>
//     </ScrollableLayout>
//   );
// }


// export function CreateCourseModal({ visible, dismissedModal, aiCourseCreated }) {
//     const navigationContext = useContext(PageContext);
//     const { showToast } = useContext(ToastContext);

//     const [currentStep, setCurrentStep] = useState(2);
//     const [previewedDocId, setPreviewedDocId] = useState(null);
//     const [page1Data, setPage1Data] = useState({
//         courseTitle: "",
//         courseDescription: "",
//         courseTemplate: 0,
//         courseDifficulty: 1,
//         courseLessonsNr: 1,
//         courseAudience: "all",
//     });

//     const [page2Data, setPage2Data] = useState({
//         learningObjectives: "",
//         researchMode: "medium",
//         courseStructureMode: "automatic",
//         AIInstructions: "",
//         courseExam: false,
//         allowFileUpload: false,
//     });

//     const [documents, setDocuments] = useState([]);
//     const [selectedDocIds, setSelectedDocIds] = useState([]);
//     const [errorMessage, setErrorMessage] = useState("");
//     const [creatingCourse, setCreatingCourse] = useState(false);
//     const [pdfFile, setPdfFile] = useState(null);
//     const [selectedPagesMap, setSelectedPagesMap] = useState({});
//     const [docsSaved, setDocsSaved] = useState(false);
//     const [savedDocuments, setSavedDocuments] = useState([]);
//     // === Document logic ===
//     const AddDocuments = async (file) => {
//         const formData = new FormData();
//         formData.append("documents", file);
//         const res = await postAPImedia("api/media/add-document", formData);
//         if (res.status === "ok") {
//         LoadDocuments();
//         } else {
//         setErrorMessage("Dit document is al eerder toegevoegd. Probeer een ander document.");
//         setTimeout(() => setErrorMessage(""), 5000);
//         }
//     };

//     const LoadDocuments = async () => {
//         const res = await getAPI("api/media/documents");
//         console.log("documents", res);
//         if (res.status === "ok") {
//             setDocuments(res.data);
//         }
//     };

//     // === Validation ===
//     function checkInput() {
//         if(currentStep === 3 && selectedDocIds.length > 0 && !docsSaved) {
//             setErrorMessage("Klik op opslaan voordat je verder gaat.");
//             return false;
//         }
//         setErrorMessage("");
//         if (!page1Data.courseTitle || !page1Data.courseDescription) {
//         setErrorMessage("Cursus titel en beschrijving is verplicht!");
//         return false;
//         }
//         if (( page1Data.courseTemplate === 1 ||  page1Data.courseTemplate === 2) && !page1Data.courseDescription) {
//         setErrorMessage("Cursusomschrijving is verplicht voor dit sjabloon!");
//         return false;
//         }
//         return true;
//     }

//     async function addCourse() {
//         setCreatingCourse(true);

//         let body = {
//             title: page1Data.courseTitle,
//             description: page1Data.courseDescription,
//             level: page1Data.courseDifficulty,
//             lesson_count: page1Data.courseLessonsNr,
//             course_template: page1Data.courseTemplate,
//             audience: page1Data.courseAudience,
//             difficulty: page1Data.courseDifficulty,
//             price: 0,
//             yt_url: "http",
//         };

//         if (page1Data.courseTemplate === 2) {
//             body = {
//             ...body,
//             goals: page2Data.learningObjectives,
//             research_mode: page2Data.researchMode,
//             structure_mode: page2Data.courseStructureMode,
//             ai_instructions: page2Data.AIInstructions,
//             exam: page2Data.courseExam,
//             allow_file_upload: page2Data.allowFileUpload,
//             documents: savedDocuments,
//             };
//         }
//         console.log("Creating course with body:", body);
//         const res = await postAPI("api/courses/create", body);
//         if ( page1Data.courseTemplate === 0 && res.status === "ok") {
//             navigationContext.handleNavigation({ navigation: 5, courseID: res.data, enrollment: 0 });
//             showToast("Cursus succesvol aangemaakt!");
//         } else{
//             aiCourseCreated();
//             navigationContext.handleNavigation({ navigation: 2, courseID: 0, enrollment: 0 });
//         }
//         setCreatingCourse(false);
//     }

//     function selectPDF(id_document) {
//         const doc = documents.find(d => d.id_document === id_document);
//         const url = `${ip}/api/media/documents/${doc.title}.pdf`;

//         if (previewedDocId === id_document) {
//             setPreviewedDocId(null);
//             setPdfFile(null);
//         } else {
//             setPreviewedDocId(id_document);
//             setPdfFile(url);
//         }
//     }

//     function previous_step() {
//         setCurrentStep((s) => Math.max(s - 1, 1));
//     }

//     function handleNext() {
//         if (!checkInput()) return;
//         if ( page1Data.courseTemplate === 0) {
//             addCourse();
//             return;
//         }
//         if (currentStep < 3) {
//             setCurrentStep((s) => s + 1);
//         } else {
//             addCourse();
//         }
//     }

//     function getNextButtonLabel() {
//         if ( page1Data.courseTemplate === 0) return creatingCourse ? "Bezig..." : "Aanmaken";
//         if (currentStep < 3) return "Volgende";
//         return creatingCourse ? "Bezig..." : "Aanmaken";
//     }

//     const saveDocs = (selectedPagesMap, documents) => {
//         const savedDocs = selectedDocIds.map(id => {
//             const doc = documents.find(d => d.id_document === id);
//             return {
//                 ...doc,
//                 selectedPages: selectedPagesMap[id]?.slice() || []
//             };
//         });

//         setSavedDocuments(savedDocs);
//         setDocsSaved(true);
//         showToast("Documenten succesvol opgeslagen!"); 
//         console.log("documenten", savedDocs);
//     }
//     const modalSize = currentStep === 3 && previewedDocId ? "extra-long" : "medium";
//     useEffect(() => {
//         if (currentStep === 3) {
//             LoadDocuments();
//         }
//     }, [currentStep]);
//     useEffect(() => {
//         if (previewedDocId || selectedDocIds.length) {
//             setDocsSaved(false);
//         }
//     }, [selectedDocIds, previewedDocId]);
//     const isDocSelected = previewedDocId !== null;
//   return (
//     <Modal height={null} dismissable={dismissedModal} visible={visible} size={modalSize} content={
//       <>
//         <ModalTitle title="Cursusinstellingen" />
//         <ModalBody content={
//           <>
//             <GridLayout gap="1rem" columnsTemplate="1fr 1fr 1fr">
//               <NewStep status={currentStep === 1 ? "active" : currentStep > 1 ? "completed" : "disabled"} number={1} title="Cursusinformatie" />
//               <NewStep status={currentStep === 2 ? "active" : currentStep > 2 ? "completed" : "disabled"} number={2} title="AI-configuratie" />
//               <NewStep status={currentStep === 3 ? "active" : "disabled"} number={3} title="Documenten" />
//             </GridLayout>

//             {errorMessage && <Alert className={"standard-margin-top"} type="error" message={errorMessage} />}
//             <RenderContent
//                 handleSave={() => saveDocs(selectedPagesMap, documents)}
//                 isDocSelected={isDocSelected}
//                 selectedPagesMap={selectedPagesMap[previewedDocId] || []}
//                 setSelectedPagesMap={setSelectedPagesMap}
//                 pdfFile={pdfFile}
//                 selectPDF={selectPDF}
//                 previewedDocId={previewedDocId}
//                 currentStep={currentStep}
//                 AddDocuments={AddDocuments}
//                 documents={documents}
//                 selectedDocIds={selectedDocIds}
//                 setSelectedDocIds={setSelectedDocIds}
//                 page1Data={page1Data}
//                 setPage1Data={setPage1Data}
//                 page2Data={page2Data}
//                 setPage2Data={setPage2Data}
//             />
//           </>
//         }/>
//         <ModalFooter>
//           {currentStep !== 1 && (
//             <StandardButton size="small" arrow={"left"} onClick={previous_step} title={"Vorige"} />
//           )}
//           <StandardButton
//             size="small"
//             arrow={ page1Data.courseTemplate === 0 || currentStep === 3 ? "" : "right"}
//             onClick={handleNext}
//             title={getNextButtonLabel()}
//           />
//         </ModalFooter>
//       </>
//     }/>
//   );
// }

// const RenderContent = ({handleSave,isDocSelected,selectedPagesMap,setSelectedPagesMap,pdfFile, selectPDF, previewedDocId, currentStep, AddDocuments, documents, selectedDocIds, setSelectedDocIds, page1Data, setPage1Data, page2Data, setPage2Data }) => {
//   switch (currentStep) {
//     case 1:
//       return <CreateCoursePage1 data={page1Data} setData={setPage1Data} />;
//     case 2:
//       return <CreateCoursePage2 data={page2Data} setData={setPage2Data} />;
//     case 3:
//       return (
//         <HorizontalLayout className="standard-margin-top documents-container">
//          <VerticalLayout className={`standard-padding documents-selector ${isDocSelected && "selected"}`} >
//             <DocumentsPanel
//                 previewedDocId={previewedDocId}
//                 selectPDF={selectPDF}
//                 style={{ marginTop: "1rem" }}
//                 onFileUpload={(files) => AddDocuments(files)}
//                 documents={documents}
//                 selectedDocIds={selectedDocIds}
//                 setSelectedDocIds={setSelectedDocIds}
//             />
//         </VerticalLayout>
//         {previewedDocId && (
//                 <VerticalLayout className="standard-padding pdf-preview">
//                     <PDFPreview
//                         handleSave={handleSave}
//                         docId={previewedDocId}
//                         selectedPages={selectedPagesMap[previewedDocId] || []}
//                         fileUrl={pdfFile}
//                         setSelectedPages={(pages) =>
//                                 setSelectedPagesMap(prev => ({
//                                     ...prev,
//                                     [previewedDocId]: pages,
//                                 }))
//                             }
//                         style={{ height: "100%", maxHeight: "471px", width: "100%" }}
//                     />
//                 </VerticalLayout>

//             )}
//             </HorizontalLayout>
//       );
//     default:
//       return null;
//   }
// };


function ModalSpinner({ title = "Cursus aanmaken..." }) {
    return (
        <div style={{
            position: "absolute",
            animation: "0.25s fade-in-top ease-out",
            top: "0px",
            left: "0px",
            background: "#fffa",
            width: "100%",
            height: "100%",
            zIndex: 999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "1rem"
            }}>
                <Spinner />
                <p>{title}</p>
            </div>
        </div>
    )
}

export function MFAModal({ visible, dismissedModal }) {
    const userContext = useContext(UserContext);
    const [mfaSetupPage, setMfaSetupPage] = useState("start")
    const [authenticatorInfo, setAuthenticatorInfo] = useState({ "uri": "", "key": "" });
    const [enteredMfa, setEnteredMFA] = useState();
    const [mfaVerifyResponse, setMfaVerifyResponse] = useState({});


    async function setup_authenticator() {
        setMfaSetupPage("start-between");
        var setup_totp = await postAPI("api/auth/mfa/totp/create", { "type": "authenticator" });
        setAuthenticatorInfo(setup_totp);
        setTimeout(function () {
            setMfaSetupPage("qr-totp");
        }, 2000);
    }

    async function verify_authenticator() {
        var verify_totp = await postAPI("api/auth/mfa/totp/verify", { "code": enteredMfa, "submit_code": authenticatorInfo.submit_code });
        setMfaVerifyResponse(verify_totp);

        if (verify_totp.success == true) {
            setMfaSetupPage("finished")
        }
    }

    return <Modal
        dismissable={dismissedModal}
        visible={visible}
        size="small"
        content={
            <>
                <ModalTitle dismissable={dismissedModal} hasXmark={true} title="2-staps verificatie instellen" />
                <ModalBody
                    content={
                        <>
                            {/* <div style={{textAlign: "center"}}>
                                <Spinner style={{"marginTop": "2rem"}} size="1.5rem"/>
                                <p style={{"marginTop": "0.5rem", marginBottom: "2rem", fontSize: "0.75rem", color: "var(--grey-700)"}}>Een moment geduld a.u.b...</p>
                            </div> */}
                            {mfaSetupPage == "start" && <>
                                <div>
                                    Hoe wilt u gaan inloggen bij Expligo?
                                </div>
                                <br />
                                <GridLayout columnsTemplate="1fr" rowTemplate="1fr 1fr" gap="1rem">
                                    {/* <div className="mfa-option">
                                        <p className="mfa-icon">{icon("mail", 64)}</p>
                                        <p className="mfa-option-title">E-mail</p>
                                        <p className="mfa-option-description">U ontvangt een 6-cijferige code via e-mail, en gebruikt deze om in te loggen. <span style={{ "color": "red" }}>(Niet aanbevolen!)</span></p>
                                    </div> */}
                                    <div onClick={() => setup_authenticator()} className="mfa-option">
                                        <p className="mfa-icon">{icon("totp", 64)}</p>
                                        <p className="mfa-option-title">Authenticator app</p>
                                        <p className="mfa-option-description">U ontvangt een 6-cijferige code in uw Authenticator app, en gebruikt deze om in te loggen.</p>
                                    </div>
                                </GridLayout>
                            </>}
                            {mfaSetupPage == "start-between" && <>
                                <div style={{ textAlign: "center" }}>
                                    <Spinner style={{ "marginTop": "2rem" }} size="1.5rem" />
                                    <p style={{ "marginTop": "0.5rem", marginBottom: "2rem", fontSize: "0.75rem", color: "var(--grey-700)" }}>Een moment geduld a.u.b...</p>
                                </div>
                            </>}
                            {mfaSetupPage == "qr-totp" && <>
                                <div style={{ "marginBottom": "1rem", "maxWidth": "30rem" }}>
                                    Scan de QR-code met een authenticator-app en vul de 6-cijferige code in die wordt getoond.
                                </div>
                                <div style={{ "textAlign": "center" }}>
                                    <QRCode value={authenticatorInfo.uri} />
                                    <p style={{ "fontSize": "0.75rem", "color": "var(--grey-700)" }}>{authenticatorInfo.key}</p>
                                </div>
                                <div style={{ "marginTop": "2rem" }}>
                                    {mfaVerifyResponse.error && <><Alert type="error" message={mfaVerifyResponse.error} /><br /></>}
                                    <InputForm title="Authenticator code" typeInput={(v) => setEnteredMFA(v)} value={enteredMfa} placeholder="000000" />
                                </div>
                            </>}
                            {mfaSetupPage == "finished" && <>
                                <VerticalLayout style={{ "gap": "0.5rem", "marginTop": "1rem", "alignItems": "center", "textAlign": "center", "width": "100%", "padding": "0rem 2rem", "boxSizing": "border-box" }}>
                                    <span style={{ "color": "var(--success-600)" }}>{icon("check-circle", 64)}</span>
                                    <p className="small-standard-margin-top">Gelukt!<br /><span style={{ "fontSize": "0.75rem", "color": "var(--grey-700)" }}>Dit account heeft nu een extra laag van beveiliging.</span></p>
                                </VerticalLayout>
                            </>}
                        </>
                    }
                />
                <ModalFooter
                    content={
                        <>
                            {mfaSetupPage == "qr-totp" && <>
                                <StandardButton onClick={() => setMfaSetupPage("start")} title={"Vorige"} />
                                <StandardButton onClick={() => verify_authenticator()} title={"Volgende"} />
                            </>}
                            {mfaSetupPage == "finished" && <>
                                <StandardButton onClick={() => { dismissedModal(); setTimeout(function () { setMfaSetupPage("start") }, 1000) }} title={"Afronden"} />
                            </>}
                        </>
                    }
                />
            </>
        }
    />
}

export function ImageSelectorModal({ visible, imageSelected }) {
    const [imageSelectionOption, setImageSelectionOption] = useState(1);
    const [imageSearchInput, setImageSearchInput] = useState("");
    const [imageSearchResults, setImageSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);

    function selectImage(image) {
        if (imageSelectionOption === 1) {
            imageSelected({ type: imageSelectionOption, image: image });
        } else if (imageSelectionOption === 2) {
            var file = image.target.files[0];
            imageSelected({ type: imageSelectionOption, image: file, fileName: file.name });
        }
    }

    async function searchImages(query) {
        if (query.length < 3) return;
        setLoading(true);
        var result = await getAPI(`api/media/search?q=${query}`);
        setImageSearchResults(result.data);
        setLoading(false);
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            searchImages(imageSearchInput);
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [imageSearchInput]);

    return (
        <Modal
            dismissable={() => { }}
            visible={visible}
            size="small"
            content={
                <>
                    <ModalTitle hasXmark={false} title="Afbeelding kiezen" />
                    <ModalBody
                        content={
                            <>
                                <Tabs
                                    selectedTab={imageSelectionOption}
                                    tabs={[
                                        { title: "Afbeeldingzoeker", id: 1 },
                                        { title: "Uploaden", id: 2 }
                                    ]}
                                    onTabClick={(id) => setImageSelectionOption(id)}
                                />
                                {imageSelectionOption === 1 && (
                                    <div>
                                        <br />
                                        <InputForm
                                            title=""
                                            placeholder="Begin met typen om te zoeken..."
                                            typeInput={setImageSearchInput}
                                            value={imageSearchInput}
                                        />
                                        {imageSearchInput.length < 3 ? (
                                            <VerticalLayout
                                                className="center-all"
                                                style={{
                                                    marginTop: "1rem",
                                                    height: "188px",
                                                    width: "420px"
                                                }}
                                            >
                                                <span className="small-standard-margin" style={{ color: "var(--standard-text-color)" }}>
                                                    {icon("search", 48)}
                                                </span>
                                                <span style={{ color: "var(--standard-text-color-light)" }}>
                                                    Typ een zoekopdracht in!
                                                </span>
                                            </VerticalLayout>
                                        ) : loading ? (
                                            <VerticalLayout
                                                className="center-all"
                                                style={{
                                                    marginTop: "1rem",
                                                    height: "188px",
                                                    width: "420px"
                                                }}
                                            >
                                                <p>Laden...</p>
                                                <Spinner />
                                            </VerticalLayout>
                                        ) : imageSearchResults.length === 0 ? (
                                            <VerticalLayout
                                                className="center-all"
                                                style={{
                                                    marginTop: "1rem",
                                                    height: "188px",
                                                    width: "420px"
                                                }}
                                            >
                                                <span className="small-standard-margin" style={{ color: "var(--grey-500)" }}>
                                                    {icon("search", 48)}
                                                </span>
                                                <span style={{ color: "var(--grey-800)" }}>
                                                    Geen resultaten gevonden.
                                                </span>
                                            </VerticalLayout>
                                        ) : (
                                            <GridLayout
                                                className="image-selection-grid"
                                                style={{ width: "420px" }}
                                                columnsTemplate="1fr 1fr 1fr"
                                                gap="0.75rem"
                                            >
                                                {imageSearchResults.map((image) => (
                                                    <div
                                                        key={image.id}
                                                        onClick={() => selectImage(image)}
                                                        className="image-selection-preview"
                                                    >
                                                        <SkeletonDiv
                                                            style={{
                                                                height: "5.5rem",
                                                                borderRadius: "0.5rem"
                                                            }}
                                                        />
                                                        <img
                                                            src={image.url}
                                                            alt="search result"
                                                            onLoad={(e) => (e.target.style.display = "block")}
                                                        />
                                                    </div>
                                                ))}
                                            </GridLayout>
                                        )}
                                    </div>
                                )}
                                {imageSelectionOption === 2 && (
                                    <div style={{ width: "420px" }}>
                                        <br />
                                        <InputFile
                                            fileChange={(e) => selectImage(e)}
                                            title={null}
                                            icon2="add-image"
                                            verb="Voeg afbeelding toe"
                                            placeholder="Example.png"
                                            supporting="png, jpeg zijn toegestaan"
                                        />
                                    </div>
                                )}
                            </>
                        }
                    />
                </>
            }
        />
    );
}



export function ImageSelectorModalCopy({ visible, imageSelected, dismiss, type }) {
    const [imageSelectionOption, setImageSelectionOption] = useState(type === "avatar-bg" ? 3 : 1);
    const [imageSearchInput, setImageSearchInput] = useState("");
    const [imageSearchResults, setImageSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [selectedColors, setSelectedColors] = useState(["#ffffffff", "#000000ff"]);


    function selectImage(image) {
        if (imageSelectionOption === 1) {
            imageSelected({ type: imageSelectionOption, image: image });
        } else if (imageSelectionOption === 2) {
            const file = image.target.files[0];
            const validTypes = ["image/jpeg", "image/png"];
            if (!validTypes.includes(file.type)) {
                setErrorMessage("Alleen PNG of JPEG bestanden zijn toegestaan.");
                setTimeout(() => setErrorMessage(""), 5000);
                return;
            }
            addImage(file);
        } else if (imageSelectionOption === 3) {
            imageSelected({ type: 3, colors: selectedColors });
            dismiss();
        }
    }

    async function addImage(image) {
        try {
            const formData = new FormData();
            formData.append("file", image);
            const result = await postAPImedia("api/media/add-media", formData);
            imageSelected({ type: 2, image: { url: `${ip}/api/media/${result.data.url}` } });
            dismiss();
        } catch (error) {
            console.error("Upload mislukt", error);
            setErrorMessage("Uploaden is mislukt. Probeer opnieuw.");
            setTimeout(() => setErrorMessage(""), 5000);
        }
    }

    async function searchImages(query) {
        if (query.length < 3) return;
        setLoading(true);
        var result = await getAPI(`api/media/search?q=${query}`);
        setImageSearchResults(result.data);
        setLoading(false);
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            searchImages(imageSearchInput);
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [imageSearchInput]);

    return (
        <Modal
            dismissable={dismiss}
            visible={visible}
            size="small"
            content={
                <>
                    <ModalTitle title={`${type === "avatar-bg" ? "Achtergrond" : "Afbeelding"} kiezen`} />
                    <ModalBody>
                        {type !== "avatar-bg" && <Tabs
                            selectedTab={imageSelectionOption}
                            tabs={[
                                { title: "Afbeeldingzoeker", id: 1 },
                                { title: "Uploaden", id: 2 },
                                { title: "AI Afbeelding", id: 5 },
                            ].filter(Boolean)}
                            onTabClick={(id) => setImageSelectionOption(id)}
                        />}
                        <ImageOptionFactory
                            options={imageSelectionOption}
                            imageSearchInput={imageSearchInput}
                            setImageSearchInput={(input) => setImageSearchInput(input)}
                            loading={loading}
                            imageSearchResults={imageSearchResults}
                            selectImage={(image) => selectImage(image)}
                            selectedColors={selectedColors}
                            setSelectedColors={setSelectedColors}
                            onDiagramGenerated={(data) => {
                                imageSelected({ type: 4, aiDiagram: data });
                                dismiss();
                            }}
                            onAIImageSelected={(image) => {
                                imageSelected({ type: 5, image: image });
                                dismiss();
                            }}
                        />
                        {errorMessage && <Alert type="error" message={errorMessage} />}
                    </ModalBody>
                </>
            }
        />
    );
}


function ImageOptionFactory({ options, imageSearchInput, setImageSearchInput, loading, imageSearchResults, selectImage, setSelectedColors, selectedColors, onDiagramGenerated, onAIImageSelected }) {
    switch (options) {
        case 1:
            return (
                <div>
                    <br />
                    <InputForm
                        title=""
                        placeholder="Type om te zoeken..."
                        typeInput={(value) => setImageSearchInput(value)}
                        value={imageSearchInput}
                    />
                    <SearchInput
                        selectImage={selectImage}
                        inputLength={imageSearchInput.length}
                        results={imageSearchResults}
                        loading={loading}
                    />

                </div>
            )
        case 2: return (
            <div style={{ width: "420px" }}>
                <br />
                <InputFile
                    fileChange={(e) => selectImage(e)}
                    title={null}
                    icon2="add-image"
                    verb="Voeg afbeelding toe"
                    placeholder="Example.png"
                    supporting="png, jpeg zijn toegestaan"
                    accept=".png, .jpg, .jpeg"
                />
            </div>
        )
        case 3:
            return (
                <ColorPickerForm
                    title="Kies een achtergrondkleur"
                    selectedColors={selectedColors}
                    setSelectedColors={setSelectedColors}
                    confirmColor={() => selectImage({ type: 3, color: selectedColors })}
                    supporting="Kies of typ een hex kleur, bijvoorbeeld #00A3FF"
                />
            );
        case 4:
            return (
                <div style={{ marginTop: "1rem" }}>
                    <AIDiagramGenerator onDiagramGenerated={onDiagramGenerated} />
                </div>
            );
        case 5:
            return (
                <div style={{ marginTop: "1rem" }}>
                    <AIImageGenerator onImageSelected={onAIImageSelected} />
                </div>
            );
        default: return null;
    }
}



function SearchInput({ inputLength, results, loading, selectImage }) {
    if (inputLength > 3) {
        return (loading) ? <ModalSpinner /> : <SearchResults results={results} selectImage={selectImage} />;
    }
    return <EmptyDisclaimer resultText={"Typ een zoekopdracht in!"} />

}

function SearchResults({ results, selectImage }) {
    if (results.length === 0) {
        return <EmptyDisclaimer resultText={"Geen resultaten gevonden."} />
    }
    return (<CompleteSearch
        imageSearchResults={results}
        selectImage={(image) => selectImage(image)}
    />)

}



function EmptyDisclaimer({ resultText }) {
    return (
        <VerticalLayout
            className="center-all"
            style={{
                marginTop: "1rem",
                height: "188px",
                width: "420px"
            }}
        >
            <span className="small-standard-margin" style={{ color: "var(--standard-text-color)" }}>
                {icon("search", 48)}
            </span>
            <span style={{ color: "var(--standard-text-color-light)" }}>
                {resultText}
            </span>
        </VerticalLayout>
    )
}


function CompleteSearch({ imageSearchResults, selectImage }) {
    return (
        <GridLayout
            className="image-selection-grid"
            style={{ width: "420px" }}
            columnsTemplate="1fr 1fr 1fr"
            gap="0.75rem"
        >
            {imageSearchResults.map((image) =>
                <div
                    key={image.id}
                    onClick={() => selectImage(image)}
                    className="image-selection-preview"
                >
                    <SkeletonDiv
                        style={{
                            height: "5.5rem",
                            borderRadius: "0.5rem"
                        }}
                    />
                    <img
                        src={image.url}
                        alt="search result"
                        onLoad={(e) => (e.target.style.display = "block")}
                    />
                </div>
            )}
        </GridLayout>
    )
}


export const CompleteOrderModal = ({ ref, dismiss, position, visible, orderPackage }) => {
    const [acceptExpligo, setAcceptExpligo] = useState({ expligo: false, buy: false })
    const [orderCompleted, setOrderCompleted] = useState(false)

    useEffect(() => {
        setAcceptExpligo({ expligo: false, buy: false })
    }, [orderPackage])


    const handlePayment = async () => {
        const query = "api/orders/create"
        const body = { ...orderPackage, id_reseller_package: orderPackage.id }
        if (acceptExpligo.expligo && acceptExpligo.buy) {
            await postAPI(query, body)
            // dismiss()
            setOrderCompleted(true)
        }

    }
    return (
        <Modal

            ref={ref}
            dismissable={dismiss}
            position={position}
            visible={visible}
            content={
                <>
                    <ModalTitle
                        title={"Bevestig Order"}
                        hasXmark={true}
                        dismissable={dismiss}
                    />
                    {!orderCompleted ? <ModalBody>
                        <OrderDetails
                            details={orderPackage}
                        />
                        <CheckOrder
                            handleCheck={() => setAcceptExpligo({ ...acceptExpligo, expligo: !acceptExpligo.expligo })}
                            checked={acceptExpligo.expligo} description={<>Ik ga akkoord met de <a className="standard-text-color semi-bold" target="_blank" href="https://example.com/link" rel="noreferrer">aankoop voorwaarden</a> van Expligo.</>} />
                        <CheckOrder
                            handleCheck={() => setAcceptExpligo({ ...acceptExpligo, buy: !acceptExpligo.buy })}
                            checked={acceptExpligo.buy} description={"Ik bevestig mijn aankoop bij Expligo"} />
                        <StandardButton
                            title={"Bevestig aankoop"}
                            onClick={handlePayment}
                            style={{ width: "100%", padding: "1rem", marginLeft: 0, textAlign: "center", justifyContent: "center", fontSize: "1rem", marginTop: "2rem" }} />
                    </ModalBody> : <ModalBody>
                        <VerticalLayout style={{ "gap": "0.5rem", "marginTop": "1rem", "alignItems": "center", "textAlign": "center", "width": "100%", "padding": "0rem 2rem", "boxSizing": "border-box" }}>
                            <span style={{ "color": "var(--success-600)" }}>{icon("check-circle", 64)}</span>
                            <p className="small-standard-margin-top">Uw bestelling is geplaatst!<br /><span style={{ "fontSize": "0.75rem", "color": "var(--grey-700)" }}>U ontvangt nog een e-mail met uw orderbevestiging.</span></p>
                        </VerticalLayout>
                        <StandardButton
                            title={"Sluiten"}
                            onClick={() => dismiss()}
                            style={{ width: "100%", padding: "1rem", marginLeft: 0, textAlign: "center", justifyContent: "center", fontSize: "1rem", marginTop: "2rem" }} />
                    </ModalBody>
                    }
                </>
            }
        />
    )
}

export const AICourseTitleModal = ({ visible, course, position = { x: "30rem", y: "30rem" }, dismiss, addTitle }) => {
    const ref = useRef(null)
    const [titleOptions, setTitleOptions] = useState([{ "lesson_title": "A new way of living" }, { "lesson_title": "Yeah be that" }, { "lesson_title": "fin porcupine" }])
    const [loading, setLoading] = useState(true)
    const navigationContext = useContext(PageContext)
    useEffect(() => {
        console.log(course)
        if (visible) {
            setLoading(true)
            loadTitles()
        }

    }, [visible])

    const loadTitles = async () => {

        const query = `api/courses/${navigationContext.sidebar.courseID}/generate`
        const titles = await getAPI(query)
        setTitleOptions(titles.data)
        setLoading(false)
    }

    return (
        <Modal

            ref={ref}
            dismissable={dismiss}
            position={position}
            visible={visible}
            content={
                <>
                    <ModalTitle
                        title={"Kies een les titel"}
                        hasXmark={true}
                        dismissable={dismiss}
                    />
                    <ModalBody className={"phone-modal"}>
                        {(loading) ? <ModalSpinner /> : <AICourseTitleOptions addTitle={(title) => addTitle(title)} options={titleOptions} />}
                    </ModalBody>
                </>
            }
        />
    );
};

const AICourseTitleOptions = ({ options, addTitle }) => {
    return (
        options.map((title, index) => {
            return (
                <LessonTitle
                    addTitle={() => addTitle(title)}
                    key={`${title}-${index}`}
                    title={title.lesson_title}
                />
            )
        })
    );
};

const LessonTitle = ({ title, addTitle }) => {
    return (
        <p onClick={addTitle} className="file-container small-text-dark center-text" style={{ marginBottom: "1rem", paddingTop: "0.75rem", paddingBottom: "0.75rem", textAlign: "center" }}>
            {title}
        </p>
    )
}


export const AddDepartmentModal = ({ ref, dismiss, position, visible, fetchUserDepartments }) => {
    const [departmentName, setDepartmentName] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const userInformation = useContext(UserContext)
    const isPublic = userInformation.account_type === 1

    const handleAddDepartment = async () => {
        if (!departmentName.trim()) {
            setErrorMessage(`${isPublic ? "Doelgroepsnaam" : "Afdelingsnaam"} mag niet leeg zijn.`);
            return;
        }

        setIsSubmitting(true);
        setErrorMessage("");

        try {
            const response = await postAPI("api/business/departments/create", {
                department_name: departmentName.trim(),
            });
            console.log(response.status)
            if (response.status === "ok") {

                setDepartmentName("");
                dismiss();
                fetchUserDepartments();
            } else {
                setErrorMessage(`${isPublic ? "Doelgroep" : "Afdeling"} bestaal al`);
            }
        } catch (error) {
            console.error("Error adding department:", error);
            setErrorMessage("Er is iets misgegaan bij het toevoegen.");
        }

        setIsSubmitting(false);
    };


    return (
        <Modal
            ref={ref}
            dismissable={dismiss}
            position={position}
            visible={visible}
            content={
                <>
                    <ModalTitle
                        title={`${isPublic ? "Doelgroep" : "Afdeling"} toevoegen`}
                        hasXmark={true}
                        dismissable={dismiss}
                    />
                    <ModalBody>
                        <InputForm
                            title={isPublic ? "Doelgroepsnaam" : "Afdelingsnaam"}
                            placeholder={`Voer de ${isPublic ? "doelgroepsnaam" : "afdelingsnaam"} in`}
                            value={departmentName}
                            typeInput={(e) => setDepartmentName(e)}
                        />
                        {errorMessage && (
                            <Alert
                                marginTop={"1rem"}
                                type={"error"}
                                message={errorMessage}
                            />
                        )}
                        <HorizontalLayout className="modal-actions space-between standard-margin-top">
                            <StandardButton className={"phone-no-margin-left"} onClick={dismiss} title="Annuleren" />
                            <StandardButton
                                onClick={handleAddDepartment}
                                title="Toevoegen"
                                disabled={isSubmitting}
                            />
                        </HorizontalLayout>
                    </ModalBody>
                </>
            }
        />
    );
};

export const EditCourseModal = ({ ref, dismiss, position, visible, course, loadCourse, loadStructure, isPublished, setDeactivateVisible }) => {
    const [courseName, setCourseName] = useState(course.title);
    const [errorMessage, setErrorMessage] = useState("");
    const [courseDescription, setCourseDescription] = useState(course.description);

    const handleEditCourse = async () => {
        if (!courseName.trim() || !courseDescription.trim()) {
            setErrorMessage("De titel en beschrijving mogen niet leeg zijn.");
            return;
        }
        const query = "api/courses/edit";
        const body = {
            "id_course": course.id_course, "title": courseName, "description": courseDescription
        }
        const response = await postAPI(query, body);
        if (response.status === "ok") {
            loadCourse();
            loadStructure();
            setErrorMessage("");
            dismiss();
        }
        else {
            setErrorMessage("Er is iets misgegaan bij het bijwerken van de cursus. Probeer het later opnieuw.");
        }
    }

    useEffect(() => {
        setCourseName(course.title);
        setCourseDescription(course.description);
    }, [course]);

    return (
        <Modal
            ref={ref}
            dismissable={dismiss}
            position={position}
            visible={visible}
            content={
                <>
                    <ModalTitle
                        title={"Cursus bewerken"}
                        hasXmark={true}
                        dismissable={dismiss}
                    />
                    <ModalBody>
                        <InputForm
                            title={"Titel"}
                            placeholder={"Titel"}
                            value={courseName}
                            typeInput={(e) => setCourseName(e)}
                        />
                        <TextAreaForm
                            title={"Beschrijving"}
                            placeholder={"Beschrijving"}
                            value={courseDescription}
                            typeInput={(e) => setCourseDescription(e)}
                        />
                        {errorMessage && (<Alert marginTop={"1rem"} type={"error"} message={errorMessage} />)}
                    </ModalBody>
                    <ModalFooter>
                        {!isPublished && (<StandardButton backgroundColor="white" style={{ "margin-right": "auto", "padding": "0", "height": "2.5rem", "width": "2.5rem" }} onClick={() => setDeactivateVisible(true)} >
                            {icon(
                                "trash", "30px", "var(--error-600)"
                            )}
                        </StandardButton>)}
                        <StandardButton className={"phone-no-margin-left"} onClick={dismiss} title="Annuleren" />
                        <StandardButton
                            onClick={() => handleEditCourse()}
                            title="Opslaan"
                        />
                    </ModalFooter>
                </>
            }
        />
    )
};

export const AddBusinessModal = ({ ref, dismiss, position, visible, loadCustomers }) => {
    const [business, setBusiness] = useState({ name: "" })
    const [page, setPage] = useState(false)
    const [errorMessage, setErrorMessage] = useState("");
    const validateInput = () => {
        if (!business.name) {
            setErrorMessage("Bedrijfsnaam is verplicht.");
            return false;
        } else if (!business.first_name || !business.last_name || !business.email) {
            setErrorMessage("Alle velden zijn verplicht.");
        }
        setErrorMessage("");
        return true;
    }
    const addBusinessHandler = async () => {
        if (!validateInput()) return;
        const query = "api/business/add-business"
        const body = { ...business }
        const response = await postAPI(query, body);
        if (response.status === "ok") {
            setErrorMessage("");
            loadCustomers()
            dismiss()
        } else
            setErrorMessage("Je gegevens zijn niet goed gevuld");
    }

    return (
        <Modal

            ref={ref}
            dismissable={dismiss}
            position={position}
            visible={visible}
            content={
                <>
                    <ModalTitle
                        title={"Voeg bedrijf toe"}
                        hasXmark={true}
                        dismissable={dismiss}
                    />
                    {
                        !page ?
                            <BusinessModalObj
                                nextPage={() => {
                                    if (validateInput()) {
                                        setPage(true);
                                    }
                                }}
                                setBusiness={setBusiness}
                                business={business}
                                errorMessage={errorMessage}
                            /> : <UserModalObj
                                setBusiness={setBusiness}
                                business={business}
                                addBusiness={addBusinessHandler}
                                back={() => setPage(false)}
                                errorMessage={errorMessage}
                            />
                    }




                </>
            }
        />
    )
}
export function ScoreOverviewModal({ published = false, exercises, visible = false, onDismiss }) {
    const [loading, setLoading] = useState(false)
    const [scoreData, setScoreData] = useState()
    const navigationContext = useContext(PageContext);
    const userId = navigationContext.sidebar.userId;
    const course = navigationContext.sidebar.courseID;
    const LoadScoreData = async () => {
        setLoading(true)
        let query = `api/assessments/overview/score?course=${course}&user=${userId === 0 ? "@me" : userId}`
        const load = await getAPI(query)
        console.log("score data is:", load, " and id:", userId)
        if (load.data === null) {
            setScoreData({})
        } else {
            setScoreData(load.data)
        }
        setLoading(false)
    }
    function handleNextPage() {
        navigationContext.handleNavigation({
            ...navigationContext.sidebar,
            navigation: 7,
        });
    }

    useEffect(() => {
        LoadScoreData()
    }, [visible]);
    return (
        <Modal height={null} visible={visible} size="long">
                <ModalTitle title="Scoreoverzicht" />
                    {loading && <ModalSpinner title="Scores laden..." />}
                <ModalBody style={{ minWidth: "512px", overflow: published ? "scroll" : "", maxHeight: published ? "600px" : "" }} >
                    {published ? (<Review scoreData={scoreData} loading={loading} exercises={exercises} />) : (<ScoreOverview title="Resultaten" data={scoreData} />)}
                </ModalBody>   
                <ModalFooter>
                    <HorizontalLayout style={{ width: "100%", justifyContent: "flex-end" }}>
                        <StandardButton
                            title="Ga naar overzicht"
                            onClick={() => {
                                if (onDismiss) onDismiss();
                                handleNextPage();
                            }}
                        />
                    </HorizontalLayout>
                </ModalFooter>
        </Modal>
    );
}

export const CreateProjectModal = ({ dismiss, position, visible, onSave, onWorkflowRemoved }) => {
    const [projectName, setProjectName] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState(1);
    const [errorMessage, setErrorMessage] = useState("");
    const userInformation = useContext(UserContext)
    const isPublic = userInformation.account_type === 1

    const handleSave = () => {
        if (!projectName.trim() || !description.trim()) {
            setErrorMessage(`${isPublic ? "Campagne" : "Workflow"} en beschrijving mag niet leeg zijn.`);
            setTimeout(() => {
                setErrorMessage("");
            }, 3000)
            return;
        }
        setErrorMessage("");
        // {isPublic ? createCampagne({ campagne_name: projectName, description, status }) : createWorkflow({ project_name: projectName, description, status })}
        onSave({[isPublic ? "campagne_name" : "project_name"]: projectName, description, status });
        onWorkflowRemoved?.();
        dismiss();

    };
    return (
        <Modal
            size={"medium"}
            dismissable={dismiss}
            position={position}
            visible={visible}
            height={500}
            content={
                <>
                    <ModalTitle
                        title={isPublic ? "Maak een campagne aan" : "Maak een workflow aan"}
                        hasXmark={false}
                        dismissable={dismiss}
                    />
                    <ModalBody content={
                        <>
                            <InputForm
                                title={isPublic ? "Campagne naam" : "Workflow naam"}
                                value={projectName}
                                typeInput={(val) => setProjectName(val)}
                            />
                            <TextAreaForm
                                title="Beschrijving"
                                value={description}
                                typeInput={(val) => setDescription(val)}
                            />
                            <SelectInputForm
                                title="Status"
                                value={status}
                                defaultValue={1}
                                options={[
                                    <option value={0}>Inactief</option>,
                                    <option value={1}>Actief</option>,
                                    <option value={2}>Gepauzeerd</option>
                                ]}
                                onChange={(val) => setStatus(val)}
                            />
                            {errorMessage && <Alert type="error" message={errorMessage} />}
                        </>
                    } />
                    <ModalFooter content={
                        <>
                            <StandardButton
                                textColor="white"
                                onClick={handleSave}
                                title="Opslaan"
                            />
                            <StandardButton
                                style={{ borderColor: "var(--grey-500)", fontWeight: "700" }}
                                textColor="primary-600"
                                backgroundColor="white"
                                onClick={dismiss}
                                title="Sluiten"
                            />
                        </>
                    } />
                </>
            }
        />
    );
};

export const LeadEmailModal = ({ visible, onDismiss, onSubmit }) => {
    const [email, setEmail] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleSubmit = () => {
        setErrorMessage("");

        if (!email.trim()) {
            setErrorMessage("E-mailadres is verplicht.");
            return;
        }

        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setErrorMessage("Voer een geldig e-mailadres in.");
            return;
        }

        onSubmit(email);
    };

    return (
        <Modal
            size={"small"}
            dismissable={onDismiss}
            visible={visible}
            content={
                <>
                    <ModalTitle title={"Je hebt de cursus succesvol afgerond!"} hasXmark={true} dismissable={onDismiss} />
                    <ModalBody>
                        <p>Ontvang je resultaten direct in je mailbox.</p>
                        <br />
                        <InputForm
                            title="E-mailadres"
                            placeholder="naam@voorbeeld.nl"
                            value={email}
                            typeInput={(e) => setEmail(e)}
                        />
                        <p style={{
                            fontSize: "0.75rem",
                            color: "var(--grey-600)",
                            marginTop: "0.5rem",
                            marginBottom: "0"
                        }}>
                            Wij sturen geen spam, beloofd!
                        </p>
                        {errorMessage && (
                            <Alert
                                marginTop={"1rem"}
                                type={"error"}
                                message={errorMessage}
                            />
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <StandardButton
                            onClick={onDismiss}
                            title="Nee, bedankt"
                            backgroundColor="white"
                            textColor="var(--grey-600)"
                            style={{ borderColor: "var(--grey-300)" }}
                        />
                        <StandardButton
                            onClick={handleSubmit}
                            title="Ja, prima"
                        />
                    </ModalFooter>
                </>
            }
        />
    )
}

export const SuggestionModal = ({ ref, dismiss, position, visible }) => {
    const suggestions = [
        { title: "Verbeter je cursusstructuur", description: "Herorganiseer hoofdstukken om de leerflow te optimaliseren." },
        { title: "Gebruik quizzen aan het einde van een module", description: "Test het begrip van de student met korte evaluaties." },
        { title: "Personaliseer het dashboard van de student", description: "Toon voortgang en aanbevolen modules voor een beter overzicht." }
    ];

    return (
        <Modal
            size={"long"}
            ref={ref}
            dismissable={dismiss}
            position={position}
            visible={visible}
            content={
                <>
                    <ModalTitle
                        title="Aanbevolen suggesties"
                        hasXmark={false}
                        dismissable={dismiss}
                    />
                    <ModalBody content={
                        <>
                            <StandardComp editClass={"suggest-comp-container"} content={
                                <>
                                    {suggestions.map((item) => (
                                        <StandardComp
                                            style={{ width: "auto" }}
                                            editClass={"horizontal suggest-comp"}
                                            content={
                                                <>
                                                    <VerticalLayout>
                                                        <p className="standard-text-color">{item.title}</p>
                                                        <p className="small-text-light">{item.description}</p>
                                                    </VerticalLayout>
                                                    <StandardButton size="medium" arrow={"right"} />
                                                </>
                                            }
                                        />
                                    ))}
                                </>
                            } />
                        </>
                    } />
                    <ModalFooter content={
                        <>
                            <StandardButton style={{ borderColor: "var(--grey-500)", fontWeight: "700" }} textColor="primary-600" backgroundColor="white" onClick={dismiss} title="Sluiten" />
                        </>
                    } />
                </>
            }
        />
    );
};

const BusinessModalObj = ({ setBusiness, errorMessage, business, nextPage }) => {
    return (
        <ModalBody>
            <InputForm
                title={"Bedrijfsnaam"}
                placeholder={"Bedrijfsnaam"}
                value={business.name}
                typeInput={(e) => setBusiness({ ...business, name: e })}
            />{errorMessage && (
                <Alert
                    marginTop={"1rem"}
                    type={"error"}
                    message={errorMessage}
                />
            )}
            <StandardButton
                title={"Volgende"}
                onClick={nextPage}
                style={{ padding: "0.5rem", marginLeft: "auto", textAlign: "center", justifyContent: "center", fontSize: "0.75rem", marginTop: "2rem" }} />

        </ModalBody>
    )
}


const UserModalObj = ({ setBusiness, errorMessage, business, addBusiness, back }) => {
    return (
        <ModalBody>
            <InputForm
                title={"Voornaam"}
                placeholder={"Voornaam"}
                value={business?.first_name}
                typeInput={(e) => setBusiness({ ...business, first_name: e })}
            />
            <InputForm
                title={"Achternaam"}
                placeholder={"Achternaam"}
                value={business?.last_name}
                typeInput={(e) => setBusiness({ ...business, last_name: e })}

            />
            <InputForm
                title={"Email"}
                placeholder={"Email"}
                value={business?.email}
                typeInput={(e) => setBusiness({ ...business, email: e })}

            />
            {errorMessage && (
                <Alert
                    marginTop={"1rem"}
                    type={"error"}
                    message={errorMessage}
                />
            )}
            <HorizontalLayout style={{ margin: 0, padding: 0 }}>
                <StandardButton
                    title={"Ga terug"}
                    onClick={back}
                    backgroundColor="var(--grey-300)"
                    textColor="var(--grey-600)"
                    style={{ padding: "0.6rem", color: "var(--grey-600)", marginRight: "auto", marginLeft: 0, textAlign: "center", justifyContent: "center", fontSize: "0.75rem", marginTop: "2rem" }} />

                <StandardButton
                    title={"Voeg bedrijf toe"}
                    onClick={addBusiness}
                    style={{ padding: "0.6rem", marginLeft: "auto", textAlign: "center", justifyContent: "center", fontSize: "0.75rem", marginTop: "2rem" }} />
            </HorizontalLayout>
        </ModalBody>
    )
}


export const CustomRoleModal = ({ visible, dismiss, addRole, error }) => {
    const [roleInput, setRoleInput] = useState("")
    const handleInput = (value) => {
        setRoleInput(value)
    }
    const userInformation = useContext(UserContext)
    const isPublic = userInformation.account_type === 1

    return (
        <Modal
            visible={visible}
            dismissable={dismiss}
            content={
                <>
                    <ModalTitle
                        title={isPublic ? "Leadsrol" : "Gebruikersrol"}
                    />
                    <ModalBody>
                        {error !== "" && <><Alert
                            type={"error"}
                            message={error}
                        /><br /></>}
                        <InputForm
                            title="Naam rol"
                            placeholder={"Bijv. Beheerder"}
                            typeInput={(input) => handleInput(input)}
                            value={roleInput}
                        />
                    </ModalBody>
                    <StandardButton
                        title={`Voeg ${isPublic ? "leadsrol" : "gebruikersrol"} toe`}
                        onClick={() => addRole(roleInput)}
                        style={{ padding: "0.6rem", marginLeft: "auto", textAlign: "center", justifyContent: "center", fontSize: "0.75rem", marginTop: "0rem", margin: "1rem", width: "calc(100% - 2rem)" }} />
                </>
            }
        />
    )
}

export const StatsRowModal = ({
    visible,
    dismiss,
    activeIndex,
    onSave,
    currentKey,
    onClick,
    stat,
    customerStage
}) => {
    const isAddMode = currentKey === null;
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState();
    const [selectedKey, setSelectedKey] = useState(currentKey);
    const [dropdownOptions, setDropdownOptions] = useState([{ content: "", id: 1 }])

    // Period options
    const periodOptions = [
        { id: 3, content: "3 maanden" },
        { id: 6, content: "6 maanden" },
        { id: 12, content: "12 maanden" },
        { id: 24, content: "24 maanden" },
    ];

    const loadKPI = async () => {
        const query = `api/reports/dashboard/options/available?customer_stage=${customerStage}`
        const kpiDropdown = await getAPI(query)
        setDropdownOptions(kpiDropdown.data)

    }

    const updateKPI = async () => {
        const query = 'api/reports/dashboard/update'
        const option = {...dropdownOptions[selectedIndex], order:activeIndex}
        const period = dropdownOptions.filter((option) => option.id = selectedPeriod)[0]
        const body = { old_id_dashboard:stat.id_dashboard, id_dashboard: option.id, period: period.id, order:selectedIndex }
        console.log(body)
        const update = await updateAPI(query, body)
        if (update.status == "ok") {
            onSave()
            dismiss()
        }
    }

    const addKPI = async () => {
        const query = 'api/reports/dashboard/add'
        const option = {...dropdownOptions[selectedIndex], order:activeIndex}
        const period = dropdownOptions.filter((option) => option.id = selectedPeriod)[0]
        const body = { id_dashboard: option.id, period: period.id }
        console.log(body)
        const update = await postAPI(query, body)
        if (update.status == "ok") {
            onSave()
            dismiss()
        }
    }

    const removeKPI = async () => {
        const query = 'api/reports/dashboard/remove'
        console.log(stat)
        const body = { id_dashboard: stat.id_dashboard }
        console.log(body)
        const update = await postAPI(query, body)
        if (update.status == "ok") {
            onSave()
            dismiss()
        }
    }
    useEffect(() => {
        loadKPI()
    }, [])
    // Dropdown options: use pretty_name from availableKeysFromAPI if present, fallback to key

    return (
        <Modal
            visible={visible}
            dismissable={dismiss}
            content={
                <>
                    <ModalTitle
                        hasXmark={true}
                        dismissable={dismiss}
                        title={isAddMode ? "Voeg een nieuwe module toe" : "Wijzig deze module"}
                    />
                    <ModalBody>
                        {dropdownOptions.length === 0 ? (
                            <VerticalLayout>
                            <div style={{ padding: "1rem", color: "var(--standard-text-color-light)", fontStyle: "italic" }}>
                             Geen nieuwe modules beschikbaar
                            </div>
         
                                     <StandardComp
                                        style={{ marginRight: 0, marginBottom: "1rem", padding: ".75rem" }}
                                        content={
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <div className="normal-text-dark" style={{ fontWeight: "bold" }}>
                                                    {stat.name || currentKey}
                                                </div>
                                                <StandardButton
                                                    onClick={removeKPI}
                                                    backgroundColor="white"
                                                    style={{ border: "1px solid var(--divider-border-color)", borderRadius: "0.3rem", padding: "0.1rem" }}
                                                >
                                                    {icon("x", "20px", "var(--error-600)")}
                                                </StandardButton>
                                            </div>
                                        }
                                    />
                            </VerticalLayout>
                        ) : (
                            <>
                                {!isAddMode && (

                                    <StandardComp
                                        style={{ marginRight: 0, marginBottom: "1rem", padding: ".75rem" }}
                                        content={
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <div className="normal-text-dark" style={{ fontWeight: "bold" }}>
                                                    {stat.name || currentKey}
                                                </div>
                                                <StandardButton
                                                    onClick={removeKPI}
                                                    backgroundColor="white"
                                                    style={{ border: "1px solid var(--divider-border-color)", borderRadius: "0.3rem", padding: "0.1rem" }}
                                                >
                                                    {icon("x", "20px", "var(--error-600)")}
                                                </StandardButton>
                                            </div>
                                        }
                                    />
                                )}

                                <p className="small-text-dark">Module</p>
                                <DropdownButton
                                    classContent="module-dropdown"
                                    classButton="module-dropdown-btn"
                                    dropdownStyle={{ position: "relative", width: "100%" }}
                                    dropdown={dropdownOptions}
                                    content={
                                        selectedIndex !== null && dropdownOptions[selectedIndex]
                                            ? dropdownOptions[selectedIndex].content
                                            : "Selecteer module"
                                    }
                                    optionSelected={(id) => {
                                        const index = dropdownOptions.filter((option, index) => {
                                            if (option.id == id) {
                                                option.index = index
                                                return option
                                            }

                                        })[0].index
                                        setSelectedIndex(index);
                                        setSelectedKey(dropdownOptions[id]);
                                    }}
                                />

                                <p className="small-text-dark" style={{ marginTop: "1rem" }}>Periode</p>
                                <DropdownButton
                                    width="100%"
                                    classContent="period-dropdown"
                                    classButton="period-dropdown-btn"
                                    dropdownStyle={{ position: "relative", width: "100%" }}
                                    dropdown={periodOptions.map(opt => ({
                                        ...opt,
                                        selected: selectedPeriod === opt.id,
                                    }))}
                                    content={periodOptions.find(opt => opt.id === selectedPeriod)?.content || "Selecteer periode"}
                                    optionSelected={(id) => setSelectedPeriod(id)}
                                />

                                <HorizontalLayout style={{ justifyContent: "flex-end", marginTop: ".75rem" }}>
                                    <StandardButton
                                        title={isAddMode ? "Toevoegen" : "Opslaan"}
                                        onClick={isAddMode ?addKPI:updateKPI}
                                    />
                                </HorizontalLayout>
                            </>
                        )}
                    </ModalBody>
                </>
            }
        />
    );
};

export const FaseModal = ({ visible,  dateRanges ,dismiss, stepId, type, initialValue = "", title = "Nieuwe item", label = "Naam", placeholder = "", error = "", dataOptions = [], project, onCourseAdded, onWorkflowRemoved, onDateRangeChange, campagne}) => {
    const [input, setInput] = useState(initialValue);
    const [dateRange, setDateRange] = useState({start: dateRanges?.start, end: dateRanges?.end});
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const toastContext = useContext(ToastContext);
    const userInformation = useContext(UserContext);
    const isPublic = userInformation.account_type === 1;

    
    async function fetchDepartments() {
        const res = await fetchAPI("/api/business/departments");
        if (Array.isArray(res)) return res;
        return [];
    }


    async function fetchSkills() {
        const res = await fetchAPI("/api/skills");
        if (res && res.status === "ok") return res.data;
        return [];
    }

    async function fetchCourses() {
        setLoading(true)
        const res = await fetchAPI("api/courses/filter?filter=published_creation_date&order=desc");
        setLoading(false)
        return res;
    }

    const safeProject = project?.[0] || project || {};
    

    async function loadOptions() {
        if (!visible) return;

        let data = [];
        switch (type) {
            case "departments":
                data = await fetchDepartments();
                break;
            case "skills":
                data = await fetchSkills();
                break;
            case "courses":
                data = await fetchCourses();
                break;
            case "addStep":
                data = await fetchCourses();
                break;
            default:
                data = [];
                break;
        }
        setOptions(data || []);
        if (project) {
            const usedIdsSet = getUsedIds(project, type);
            const usedIds = Array.from(usedIdsSet);
            if (type === "departments" || type === "skills" || type === "courses") {
                setInput(usedIds);
            } else {
                setInput(initialValue);
            }
        } else {
            if (type === "departments" || type === "skills") {
                setInput(Array.isArray(initialValue) ? initialValue : []);
            } else {
                setInput(initialValue);
            }
        }
    }

    const today = new Date().toISOString().split("T")[0];

    function handleSave() {
    const actions = {
        dateRange: () => {
            const {start, end} = dateRange
            updateDateRange(start, end)
            onDateRangeChange?.()
        },
        delete: () => {
            isPublic ? removeCampagne() : removeWorkflow();
        },
        courses: () => {
            addCourse(input);
        },
        addStep: () => {
            !isPublic
            ? (dateRange.start && dateRange.end
                ? addStep(input)
                : toastContext.showToast(<>Selecteer geldige datums.</>, "error"))
            : (dateRange.start
                ? addStep(input)
                : toastContext.showToast(<>Selecteer een geldige publish datum.</>, "error"));
        },
        deleteStep: () => {
            removeStep()
        },
        deleteCampagneStep: () => {

        },
        dateChangeCampagne: () => {

        },
        campagne: () =>{
            dismiss()
        }
        
    };
    (actions[type] || actions.default)();
    }

    async function removeWorkflow() {
        const body = { id_workflow: safeProject.id_workflow };
        const query = `api/workflows/remove`;
        const res = await deleteAPI(query, body);
        if (res?.status === "ok") {
            dismiss();
            onWorkflowRemoved?.();
        }
    }

    async function removeCampagne() {
    const body = { id_campagne: safeProject.id_campagne };
    console.log("body", body)
    const query = `api/campagne/remove`;
    const res = await deleteAPI(query, body);
    if (res?.status === "ok") {
        dismiss();
        onWorkflowRemoved?.();
    }
    }

    async function removeStep() {
        const body = isPublic ? { id_campagne: safeProject.id_campagne, id_step: stepId } : { id_workflow: safeProject.id_workflow, id_step: stepId } ;
        console.log("body", body)
        const query = isPublic ? `api/campagne/remove-step` : `api/workflows/remove-step`;
        const res = await deleteAPI(query, body);
        if (res?.status === "ok") {
            dismiss();
            onDateRangeChange?.();
        }
    }

    async function updateDateRange(start_date, end_date) {
    const body = isPublic ? { id_step: stepId, id_campagne: safeProject.id_campagne, publish_date: start_date } : { id_step: stepId, id_workflow: safeProject.id_workflow, start_date: start_date, end_date: end_date };
    const query = isPublic ? `api/campagne/changeDate` : `api/workflows/changeDate`;
    const res = await postAPI(query, body);
    if (res?.status === "ok") {
        dismiss();
        onDateRangeChange?.();
    }
    }

    async function addCourse(input) {
    const body = { id_step: stepId, course_ids: input };
    const query = isPublic ? `api/campagne/save-courses` : `api/workflows/save-courses`;
    const res = await postAPI(query, body);
    if (res?.status === "ok") {
        dismiss();
        onCourseAdded();
    }
    }

    async function addStep(input) {
        const body = isPublic ? { id_step: safeProject.id_step, id_campagne: safeProject.id_campagne, course_ids: input, publish_date: dateRange.start} : { id_step: stepId, id_workflow: safeProject.id_workflow, course_ids: input, start_date: dateRange.start, end_date: dateRange.end }
        const query = isPublic ? `api/campagne/addStep` : `api/workflows/addStep`;
        const res = await postAPI(query, body);
        if (res?.status === "ok") {
            dismiss();
            onDateRangeChange?.();
        }
    }

    const renderCourses = () => (
        <GridLayout
            gap="1rem"
            columnsTemplate="repeat(3, 1fr)"
            rowTemplate="repeat(3, 1fr)"
            style={{
                marginTop: "1rem",
                maxHeight: "500px",
                overflowY: "auto",
                paddingRight: "0.5rem",
            }}
        >
            {options.map((course, index) => (
                <ProjectStepCardComp
                    key={course.id_course}
                    title={course.title}
                    index={index}
                    selected={input.includes(course.id_course)}
                    onClick={() =>
                        setInput((prev) =>
                            prev.includes(course.id_course)
                                ? prev.filter((id) => id !== course.id_course)
                                : [...prev, course.id_course]
                        )
                    }
                    imgUrl={
                        course.img_url ||
                        `https://ui-avatars.com/api/?name=${course.title}`
                    }
                    iconName="book"
                />
            ))}
        </GridLayout>
    );

    const titles = {
        delete: "Verwijderen",
        deleteStep: "Verwijderen",
        campagne: "Sluiten"
    };



    useEffect(() => {
        loadOptions();
    }, [visible, type]);
    const dropdownOptions = Array.from(
        new Map(
            options.map((option) => {
                let id, content;
                if (type === "departments") {
                    id = option.id_department;
                    content = option.department_name;
                } else if (type === "skills") {
                    id = option.id_skill;
                    content = option.skill_name;
                }
                return [id, { id, content }];
            })
        ).values()
    );

    function getUsedIds(project, type) {
        const ids = new Set();
        if (!project?.phases || !Array.isArray(project.phases)) return ids;

        project.phases.forEach(phase => {
            if (!Array.isArray(phase.steps)) return;
            phase.steps.forEach(step => {
                if (type === "courses" && Array.isArray(step.courses)) {
                    step.courses.forEach(course => course?.id && ids.add(course.id));
                }
                if (type === "departments" && Array.isArray(step.departments)) {
                    step.departments.forEach(dept => dept?.id && ids.add(dept.id));
                }
                if (type === "skills" && Array.isArray(step.skills)) {
                    step.skills.forEach(skill => skill?.id && ids.add(skill.id));
                }
            });
        });
        return ids;
    }

    return (
        <Modal
            size={
            type === "courses"
                ? "xl"
                : type === "departments"
                ? "medium"
                : type === "campagne"
                ? "xl"
                : "small"
            }            
            visible={visible}
            dismissable={dismiss}
            content={
                <>
                    <ModalTitle title={title} hasXmark={true} dismissable={dismiss} />
                    <ModalBody style={{ minHeight: type === "courses" && "500px" }}>
                        {(type === "skills") && (
                            <MultiSelectDropdown
                                options={dropdownOptions}
                                selectedIds={input}
                                onChange={(selected) => {
                                    setInput((prev) => {
                                        const merged = [...new Set([...prev, ...selected])];
                                        return merged;
                                    });
                                }}
                                content={
                                    input.length > 0
                                        ? dropdownOptions
                                            .filter((opt) => input.includes(opt.id))
                                            .map((opt) => opt.content)
                                            .join(", ")
                                        : placeholder
                                }
                                classButton="fase-multiselect-button"
                                classContent="fase-multiselect-content"
                                disabled={false}
                            />
                        )}
                        {type === "departments" && (
                            <VerticalLayout className="fase-checklist" style={{ border: "1px solid var(--border-color)", borderRadius: "calc(25px * var(--br-scale))", gap: "1rem", padding: "1rem", width: "auto", }}>
                                {dropdownOptions.map((opt) => {
                                    const isChecked = input.includes(opt.id);
                                    const inputId = `checkbox-${opt.id}`;
                                    return (
                                        <HorizontalLayout key={opt.id} className="space-between" style={{}}>
                                            <label className="fase-checklist-item" htmlFor={inputId}>
                                                <span>{opt.content}</span>
                                            </label>
                                            <input
                                                style={{ width: "unset", accentColor: 'var(--primary-600)', }}
                                                id={inputId}
                                                type="checkbox"
                                                checked={isChecked}
                                                onChange={(e) => {
                                                    setInput((prev) =>
                                                        e.target.checked
                                                            ? [...prev, opt.id]
                                                            : prev.filter((id) => id !== opt.id)
                                                    );
                                                }}
                                            />
                                        </HorizontalLayout>
                                    );
                                })}
                            </VerticalLayout>
                        )}
                        {type === "courses" && (loading ? (<VerticalLayout className="center" style={{ minHeight: "500px" }}><Spinner /></VerticalLayout>) : renderCourses())}
                        {type === "campagne" && <CampagneTableComp headers= {["Naam", "Antaal cursussen", "Status", "Gekopeld Leads"]}/>}
                        {type === "dateRange" && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "1rem",
                                }}
                            >
                                <label>
                                {isPublic ? `Publish datum:` :`Begin datum:`}
                                <input
                                    type="date"
                                    value={dateRange.start}
                                    min={today}
                                    onChange={(e) => {
                                    const newStart = e.target.value;

                                    setDateRange((prev) => {
                                        if (prev.end && prev.end < newStart) {
                                        return { start: newStart, end: newStart };
                                        }
                                        return { ...prev, start: newStart };
                                    });
                                    }}
                                    style={{ display: "block", marginTop: "0.25rem" }}
                                />
                                </label>
                                {!isPublic &&
                                <label>
                                Eind datum:
                                <input
                                    type="date"
                                    value={dateRange.end}
                                    min={dateRange.start || today}
                                    onChange={(e) => {
                                    const newEnd = e.target.value;

                                    setDateRange((prev) => {
                                        if (prev.start && newEnd < prev.start) {
                                        return { ...prev, end: prev.start };
                                        }
                                        return { ...prev, end: newEnd };
                                    });
                                    }}
                                    style={{ display: "block", marginTop: "0.25rem" }}
                                />
                                </label>
                                }
                            </div>
                            )}
                            {type === "delete" && (
                            <div style={{ display: "flex", gap: "1rem", flexDirection: "column" }}>
                                <label>
                                Weet je zeker dat je de workflow{" "}
                                <strong>"{safeProject.projectName}"</strong> definitief wilt verwijderen?
                                </label>
                            </div>
                            )}

                            {type === "deleteStep" && (
                            <div style={{ display: "flex", gap: "1rem", flexDirection: "column" }}>
                                <label>Weet je zeker dat je deze stap wilt verwijderen?</label>
                            </div>
                            )}

                            {type === "create" && (
                            <div style={{ display: "flex", gap: "1rem", flexDirection: "column" }}>
                                <label>
                                Title
                                <input type="text" />
                                </label>
                                <label>
                                Description
                                <input type="text" />
                                </label>
                                <label>
                                Status
                                <input type="date" />
                                </label>
                            </div>
                            )}

                        {type === "addStep" && (
                            loading ? (
                                <VerticalLayout className="center" style={{ minHeight: "24.7rem", minWidth: "36rem" }}>
                                    <Spinner />
                                </VerticalLayout>
                            ) : (
                                <div
                                    style={{
                                        display: "flex",
                                        minHeight: "20rem",
                                        minWidth: "20rem",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        gap: "1rem",
                                    }}
                                >
                                    <label style={{ maxWidth: "9rem", paddingRight: "200px", paddingLeft: "25px" }}>
                                        {isPublic ? `Publish datum:` : `Begin datum:`}
                                        <input
                                            type="date"
                                            value={dateRange.start}
                                            min={today}
                                            max={dateRange.end || undefined}
                                            onChange={(e) => {
                                                const newStart = e.target.value;
                                                setDateRange((prev) => {
                                                    if (prev.end && prev.end < newStart) {
                                                        return { ...prev, start: newStart, end: "" };
                                                    }
                                                    return { ...prev, start: newStart };
                                                });
                                            }}
                                        />
                                    </label>

                                    {!isPublic &&
                                    <label style={{ maxWidth: "9rem" }}>
                                        Eind datum:
                                        <input
                                            type="date"
                                            value={dateRange.end}
                                            min={dateRange.start || today}
                                            onChange={(e) => {
                                                const newEnd = e.target.value;
                                                setDateRange((prev) => {
                                                    if (prev.start && newEnd < prev.start) {
                                                        return { ...prev, start: newEnd, end: newEnd };
                                                    }
                                                    return { ...prev, end: newEnd };
                                                });
                                            }}

                                        />
                                    </label>}

                                    <div
                                        style={{
                                            maxHeight: "20rem",
                                            minWidth: "20rem",
                                            overflow: "hidden",
                                        }}
                                    >
                                    
                                        <label>Cursussen selecteren</label>
                                        {renderCourses()}
                                    </div>
                                </div>
                            )
                        )}
                        {error && <Alert className={"standard-margin-top"} type="error" message={error} />}
                        <StandardButton
                            title={titles[type] || "Opslaan"}
                            style={{
                                padding: "0.6rem",
                                marginLeft: "auto",
                                textAlign: "center",
                                justifyContent: "center",
                                fontSize: "0.75rem",
                                margin: "1rem",
                                width: "calc(100% - 2rem)",
                            }}
                            onClick={handleSave}
                        />
                    </ModalBody>
                </>
            }
        />
    );
};

export const AISettingsModal = ({ visible, onClose, onSave }) => {
    const [activeTab, setActiveTab] = useState(1);
    const [selectedDocIds, setSelectedDocIds] = useState([]);
    const [pdfFile, setPdfFile] = useState(null);
    const [message, setMessage] = useState("");
    const [selectedPagesMap, setSelectedPagesMap] = useState({});
    const [previewedDocId, setPreviewedDocId] = useState(null);
    const [textTranscription, setTextTranscription] = useState("");
    const [canSave, setCanSave] = useState(true);
    const [extraData, setExtraData] = useState({
        goal: "",
        format: "",
        keywords: "",
        notes: "",
    });
    const [documents, setDocuments] = useState([]);
    const tabList = [
        { id: 1, title: "Documenten" },
        { id: 2, title: "Extra" },
        { id: 3, title: "Audio" },
    ];
    const AddDocuments = async (file) => {
        const formData = new FormData();
        formData.append('documents', file);
        const query = 'api/media/add-document';
        const res = await postAPImedia(query, formData);

        if (res.status === "ok") {
            LoadDocuments();
        } else {
            setMessage("Dit document is al eerder toegevoegd. Probeer een ander document.");
            setTimeout(() => setMessage(""), 5000);
        }
    }


    function selectPDF(id_document) {
        const doc = documents.find(d => d.id_document === id_document);
        const url = `${ip}/api/media/documents/${doc.title}.pdf`;

        if (previewedDocId === id_document) {
            setPreviewedDocId(null);
            setPdfFile(null);
        } else {
            setPreviewedDocId(id_document);
            setPdfFile(url);
        }
    }

    const LoadDocuments = async () => {
        const query = 'api/media/documents';
        const res = await getAPI(query)
        if (res.status === "ok") {
            setDocuments(res.data);
        }
    }

    const handleOnSave = (extraData, selectedPagesMap, documents) => {
        if (!canSave) {
            setMessage("De transcriptie is te lang. Verkort de tekst voordat u opslaat.");
            setTimeout(() => setMessage(""), 5000);
            return;
        }
        const dataToSave = {
            extraData: { ...extraData, text_transcription: textTranscription },
            documents: selectedDocIds.map(id => {
                const doc = documents.find(d => d.id_document === id);
                return {
                    ...doc,
                    selectedPages: selectedPagesMap[id]?.slice() || []
                };
            })
        };
        onSave(dataToSave);
    }
    useEffect(() => {
        LoadDocuments();
    }, []);

    if (!visible) return;
    const isDocSelected = previewedDocId !== null;

    return (
        <Modal hidden={false} height={null} size={"extra-long"} visible={visible} dismissable={false}>
            <ModalTitle hasXmark={true} dismissable={onClose} title="AI Instellingen" />
            <ModalBody style={{ minHeight: "35rem", }}>
                <Tabs selectedTab={activeTab} tabs={tabList} onTabClick={setActiveTab} />
                {message && (<Alert className={"standard-margin-top"} message={message} type="error" />)}
                <RenderTabContent
                    setTextTranscription={setTextTranscription}
                    textTranscription={textTranscription}
                    setSelectedPagesMap={setSelectedPagesMap}
                    AddDocuments={AddDocuments}
                    documents={documents}
                    selectedDocIds={selectedDocIds}
                    selectPDF={selectPDF}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    activeTab={activeTab}
                    isDocSelected={isDocSelected}
                    pdfFile={pdfFile}
                    setSelectedDocIds={(ids) => setSelectedDocIds(ids)}
                    selectedPagesMap={selectedPagesMap[previewedDocId] || []}
                    previewedDocId={previewedDocId}
                    setCanSave={setCanSave}
                />
            </ModalBody>
            <ModalFooter>
                <StandardButton onClick={() => handleOnSave(extraData, selectedPagesMap, documents)} title={"Opslaan"} />
            </ModalFooter>
        </Modal>
    );
}


const RenderTabContent = ({textTranscription, setTextTranscription, previewedDocId, AddDocuments, documents, selectedDocIds, setSelectedDocIds, selectPDF, extraData, setExtraData, activeTab, isDocSelecteds, pdfFile, setSelectedPagesMap, selectedPagesMap, setCanSave }) => {
    switch (activeTab) {
        case 1:
            return (
                <HorizontalLayout className="standard-margin-top documents-container">
                    <VerticalLayout className={`standard-padding documents-selector ${isDocSelecteds && "selected"}`} >
                        <DocumentsPanel
                            previewedDocId={previewedDocId}
                            selectPDF={(id_document) => selectPDF(id_document)}
                            onFileUpload={(files) => AddDocuments(files)}
                            documents={documents}
                            selectedDocIds={selectedDocIds}
                            setSelectedDocIds={setSelectedDocIds}
                        />
                    </VerticalLayout>
                    {previewedDocId && (
                        <VerticalLayout className="standard-padding pdf-preview">
                            <PDFPreview
                                docId={previewedDocId}
                                selectedPages={selectedPagesMap || []}
                                setSelectedPages={(pages) => { setSelectedPagesMap(prev => ({ ...prev, [previewedDocId]: pages }))}}
                                fileUrl={pdfFile}
                                style={{ height: "100%", maxHeight: "471px", width: "100%" }}
                            />
                        </VerticalLayout>
                    )}
                </HorizontalLayout>
            );
        case 2:
            return (
                <VerticalLayout className="standard-padding standard-margin-top extra-tab" >
                    <ExtraConfigPanel extraData={extraData} setExtraData={(data) => setExtraData(data)} />
                </VerticalLayout>
            )
        case 3: 
            return (
                <TextAudioPanel textTranscription={textTranscription} setTextTranscription={setTextTranscription} setCanSave={setCanSave}/>
            )
        default:
            return;
    }
}


const TextAudioPanel = ({ textTranscription, setTextTranscription, setCanSave }) => {
    const [media, setMedia] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [collapse, setCollapse] = useState(true);
    const [textTranscriptionFailed, setTextTranscriptionFailed] = useState(false);
    const MAX_LENGTH = 2000;


    function showError() {
        if (typeof media === "string" && (media.startsWith("http://") || media.startsWith("https://"))) {
            setError("Controleer of je YouTube-video bestaat en niet langer is dan 30 minuten.");
            setTextTranscriptionFailed(true);
        } else {
            setError("Er is iets misgegaan bij het verwerken van het bestand. Probeer het later opnieuw.");
            setTextTranscriptionFailed(true);
        }
    }
    const addMedia = async () => {
        if (!media) {
            setError("Gelieve een audio bestand te uploaden.");
            setTimeout(() => setError(""), 5000);
            return;
        }
        setLoading(true);
        const formData = new FormData();
        formData.append('media', media);
        formData.append('max_length', MAX_LENGTH);
        try {
            const res = await postAPImedia("api/media/convert-upload", formData);
            if (res.status === "ok") {
                const transcription = res.data;
                setTextTranscription(transcription);
                setTextTranscriptionFailed(false);
                setError("");
            } else if (res.status === "error") {
               showError();
            }
        } catch (err) {
            setError("Er is een onverwachte fout opgetreden. Probeer het later opnieuw.");
            setTextTranscriptionFailed(true);
        }
        setTimeout(() => setError(""), 5000);
        setLoading(false);
    };

    const manageTextChange = (v) => {
        setTextTranscription(v);
        if (v.length <= MAX_LENGTH || !textTranscription) {
            setCanSave(true);
            setError("");
        } else {
            setCanSave(false);
            setError(`De transcriptie mag niet langer zijn dan ${MAX_LENGTH} tekens.`);
            setTimeout(() => setError(""), 5000);
        }
    };

    return (
        <VerticalLayout className="standard-margin-top audio-tab standard-padding">
            <p className="small-text-light standard-margin-bottom">
                Upload een <strong className="audio-tool-tip">audio*</strong> bestand en zet het om naar tekst. Na het uploaden kun je de transcriptie bekijken, aanpassen en gebruiken voor verdere AI-analyse.
            </p>
            <UploadMedia textTranscriptionFailed={textTranscriptionFailed} media={media} setMedia={setMedia} />
            <TextAreaForm
                size={!collapse && "large"}
                value={textTranscription || ""}
                typeInput={(v) => manageTextChange(v)}
            />
            <HorizontalLayout className="space-between">
                <StandardButton
                    style={{ marginLeft: "0" }}
                    onClick={addMedia}
                    title={loading ? <Spinner size="2rem" color="white" /> : "Omzetten naar tekst"}
                />
                {textTranscription && (
                    <>
                    <p className="small-text-light">
                        {textTranscription ? textTranscription.length : 0} / {MAX_LENGTH} tekens
                    </p>
                    <IconButton
                        size={30}
                        icon2={collapse ? "chevron-down" : "chevron-up"}
                        onClick={() => setCollapse(!collapse)}
                    />
                    </>
                )}
            </HorizontalLayout>

            {error && <Alert className={"standard-small-margin-top"} message={error} type="error" />}
        </VerticalLayout>
    );
};

export const DuplicateCourseModal = ({ visible, dismiss, courseTitle, onDuplicate }) => {
    const [newTitle, setNewTitle] = useState(`${courseTitle} (kopie)`);
    const [loading, setLoading] = useState(false);

    const handleDuplicate = async () => {
        if (!newTitle.trim()) return;
        setLoading(true);
        await onDuplicate(newTitle.trim());
        setLoading(false);
    };

    useEffect(() => {
        setNewTitle(`${courseTitle} (kopie)`);
    }, [courseTitle, visible]);

    return (
        <Modal dismissable={dismiss} visible={visible} size="small">
            <ModalTitle dismissable={dismiss} hasXmark={true} title="Cursus dupliceren" />
            {loading && <ModalSpinner title="Cursus dupliceren..." />}
            <ModalBody style={{ maxWidth: "400px" }}>
                <InputForm
                    title="Nieuwe cursusnaam"
                    value={newTitle}
                    typeInput={setNewTitle}
                />
            </ModalBody>
            <ModalFooter>
                <StandardButton className="secondary-button" title="Annuleren" onClick={dismiss} />
                <StandardButton title="Dupliceren" onClick={handleDuplicate} />
            </ModalFooter>
        </Modal>
    );
};

export const GoalSettingsModal = ({ visible, dismiss, goalSettings, onSave, availableMetrics,customerStage }) => {
    const [selectedMetric, setSelectedMetric] = useState(goalSettings?.metricId || null);
    const [goalValue, setGoalValue] = useState(goalSettings?.goalValue || 10);
    const [period, setPeriod] = useState(goalSettings?.period || 30);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const periodOptions = [
        { id: 7, content: "1 week" },
        { id: 14, content: "2 weken" },
        { id: 30, content: "1 maand" },
        { id: 90, content: "3 maanden" },
        { id: 180, content: "6 maanden" },
        { id: 365, content: "1 jaar" }
    ];

    useEffect(() => {
        if (goalSettings) {
            setSelectedMetric(goalSettings.metricId || null);
            setGoalValue(goalSettings.goalValue || 10);
            setPeriod(goalSettings.period || 30);
        }
    }, [goalSettings, visible]);

    const handleSave = async () => {
        if (!selectedMetric) {
            setError("Selecteer eerst een metriek.");
            setTimeout(() => setError(""), 3000);
            return;
        }
        if (!goalValue || goalValue <= 0) {
            setError("Voer een geldig doelwaarde in.");
            setTimeout(() => setError(""), 3000);
            return;
        }

        setLoading(true);
        const selectedMetricData = availableMetrics.find(m => m.id === selectedMetric);
        const newSettings = {
            metricId: selectedMetric,
            metricName: selectedMetricData?.content || "Doel",
            goalValue: parseInt(goalValue),
            period: period,
            customerStage:customerStage
        };

        try {
            await onSave(newSettings);
            dismiss();
        } catch (err) {
            setError("Er ging iets mis bij het opslaan.");
        }
        setLoading(false);
    };

    const handleGoalInputChange = (val) => {
        const numVal = val.replace(/[^0-9]/g, '');
        setGoalValue(numVal);
    };

    return (
        <Modal dismissable={dismiss} visible={visible} size="small">
            <ModalTitle dismissable={dismiss} hasXmark={true} title="Doel instellen" />
            <ModalBody style={{ minWidth: "320px" }}>
                <p className="small-text-dark" style={{ marginBottom: "0.5rem" }}>Metriek</p>
                <DropdownButton
                    classContent="module-dropdown"
                    classButton="module-dropdown-btn goal-metric-dropdown"
                    dropdownStyle={{ position: "relative", width: "100%" }}
                    dropdown={availableMetrics || []}
                    content={
                        selectedMetric
                            ? (availableMetrics.find(m => m.id === selectedMetric)?.content || "Selecteer metriek")
                            : "Selecteer metriek"
                    }
                    optionSelected={(id) => setSelectedMetric(id)}
                />

                <p className="small-text-dark" style={{ marginTop: "1rem", marginBottom: "0.5rem" }}>Doelwaarde</p>
                <input
                    type="number"
                    min="1"
                    className="standard-input goal-value-input"
                    value={goalValue}
                    onChange={(e) => handleGoalInputChange(e.target.value)}
                    placeholder="Bijv. 50"
                />

                <p className="small-text-dark" style={{ marginTop: "1rem", marginBottom: "0.5rem" }}>Periode</p>
                <DropdownButton
                    classContent="period-dropdown"
                    classButton="period-dropdown-btn goal-period-dropdown"
                    dropdownStyle={{ position: "relative", width: "100%" }}
                    dropdown={periodOptions.map(opt => ({
                        ...opt,
                        selected: period === opt.id
                    }))}
                    content={periodOptions.find(opt => opt.id === period)?.content || "Selecteer periode"}
                    optionSelected={(id) => setPeriod(id)}
                />

                {error && <Alert className="standard-small-margin-top" type="error" message={error} />}
            </ModalBody>
            <ModalFooter>
                <StandardButton
                    className="phone-no-margin-left"
                    backgroundColor="grey-200"
                    textColor="grey-700"
                    title="Annuleren"
                    onClick={dismiss}
                />
                <StandardButton
                    title={loading ? "Opslaan..." : "Opslaan"}
                    onClick={handleSave}
                    isDisabled={loading}
                />
            </ModalFooter>
        </Modal>
    );
};